(() => {
  const body = document.body;
  const html = document.documentElement;
  let lockedScrollY = 0;
  const titlePreviewBarFrame = () => {
    const frame = document.getElementById('PBarNextFrame');
    if (frame instanceof HTMLIFrameElement && !frame.title) {
      frame.title = 'Shopify preview bar';
    }
  };
  titlePreviewBarFrame();
  new MutationObserver(titlePreviewBarFrame).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  const setPreviewBarPassthrough = (enabled) => {
    document.querySelectorAll('#PBarNextFrameWrapper, #PBarNextFrame').forEach((frame) => {
      if (!(frame instanceof HTMLElement)) return;
      if (enabled) {
        if (!Object.prototype.hasOwnProperty.call(frame.dataset, 'previousPointerEvents')) {
          frame.dataset.previousPointerEvents = frame.style.pointerEvents || '';
        }
        frame.style.pointerEvents = 'none';
      } else if (Object.prototype.hasOwnProperty.call(frame.dataset, 'previousPointerEvents')) {
        frame.style.pointerEvents = frame.dataset.previousPointerEvents;
        delete frame.dataset.previousPointerEvents;
      }
    });
  };
  const lockBodyScroll = () => {
    if (body.classList.contains('is-scroll-locked')) return;
    lockedScrollY = window.scrollY || html.scrollTop || body.scrollTop || 0;
    html.classList.add('is-scroll-locked');
    body.classList.add('is-scroll-locked');
    body.style.position = 'fixed';
    body.style.top = `-${lockedScrollY}px`;
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    body.style.overflow = 'hidden';
  };
  const unlockBodyScroll = () => {
    if (!body.classList.contains('is-scroll-locked')) return;
    html.classList.remove('is-scroll-locked');
    body.classList.remove('is-scroll-locked');
    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';
    body.style.width = '';
    body.style.overflow = '';
    window.scrollTo(0, lockedScrollY);
  };
  const syncBodyLock = () => {
    const hasOpenOverlay = openOverlay();
    if (hasOpenOverlay) {
      lockBodyScroll();
      setPreviewBarPassthrough(true);
    } else {
      setPreviewBarPassthrough(false);
      unlockBodyScroll();
    }
    syncOverlayIsolation(hasOpenOverlay);
  };
  const overlaySelector = '[data-mobile-nav].open, [data-filter-drawer].open, [data-cart-drawer].open, [data-search-sheet].open, [data-newsletter-popup].open, [data-pdp-image-viewer].open';
  const overlayCompanionSelector = '.filter-mask.open, .cart-mask.open, .search-mask.open';
  const overlayIsolationState = new Map();
  const openOverlay = () => document.querySelector(overlaySelector);
  const isolateOverlayElement = (element) => {
    if (!(element instanceof HTMLElement) || overlayIsolationState.has(element)) return;
    overlayIsolationState.set(element, {
      ariaHidden: element.getAttribute('aria-hidden'),
      inert: element.inert
    });
    element.inert = true;
    element.setAttribute('aria-hidden', 'true');
  };
  const restoreOverlayIsolation = () => {
    overlayIsolationState.forEach((state, element) => {
      if (!document.contains(element)) return;
      element.inert = state.inert;
      if (state.ariaHidden === null) {
        element.removeAttribute('aria-hidden');
      } else {
        element.setAttribute('aria-hidden', state.ariaHidden);
      }
    });
    overlayIsolationState.clear();
  };
  const syncOverlayIsolation = (overlay = openOverlay()) => {
    restoreOverlayIsolation();
    if (!(overlay instanceof HTMLElement)) return;

    let current = overlay;
    while (current && current !== body) {
      const parent = current.parentElement;
      if (!parent) break;
      Array.from(parent.children).forEach((sibling) => {
        if (sibling === current || sibling.contains(overlay)) return;
        if (sibling instanceof HTMLElement && sibling.matches(overlayCompanionSelector)) return;
        isolateOverlayElement(sibling);
      });
      current = parent;
    }
  };
  const overlayScrollerSelector = '.mnav-body, [data-cart-drawer-body], .plp-filters, .search-body, .newsletter-popup-panel, .pdp-image-viewer__viewport';
  let lastTouchY = 0;
  const closestOverlayScroller = (target) => {
    if (!target || typeof target.closest !== 'function') return null;
    return target.closest(overlayScrollerSelector);
  };
  const rememberOverlayTouch = (event) => {
    if (!openOverlay() || event.touches.length !== 1) return;
    lastTouchY = event.touches[0].clientY;
  };
  const guardOverlayTouch = (event) => {
    if (!openOverlay() || event.touches.length !== 1) return;
    const scroller = closestOverlayScroller(event.target);
    if (!scroller) {
      event.preventDefault();
      return;
    }

    const currentY = event.touches[0].clientY;
    const deltaY = currentY - lastTouchY;
    lastTouchY = currentY;
    const canScroll = scroller.scrollHeight > scroller.clientHeight;
    const atTop = scroller.scrollTop <= 0;
    const atBottom = scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 1;

    if (!canScroll || (atTop && deltaY > 0) || (atBottom && deltaY < 0)) {
      event.preventDefault();
    }
  };
  const guardOverlayWheel = (event) => {
    if (openOverlay() && !closestOverlayScroller(event.target)) {
      event.preventDefault();
    }
  };
  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'summary',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');
  const overlayFocus = {
    mobileNav: null,
    filters: null,
    cart: null,
    search: null,
    newsletter: null,
    imageViewer: null
  };
  const visibleFocusable = (container) => Array.from(container.querySelectorAll(focusableSelector))
    .filter((element) => (
      !element.hasAttribute('hidden')
      && element.getAttribute('aria-hidden') !== 'true'
      && element.offsetParent !== null
    ));
  const cleanPastedRichText = (root, { allowTrustedVideoEmbeds = false } = {}) => {
    const allowedTags = new Set([
      'A',
      'BLOCKQUOTE',
      'BR',
      'EM',
      'H2',
      'H3',
      'H4',
      'IMG',
      'LI',
      'OL',
      'P',
      'STRONG',
      'TABLE',
      'TBODY',
      'TD',
      'TFOOT',
      'TH',
      'THEAD',
      'TR',
      'UL'
    ]);
    if (allowTrustedVideoEmbeds) allowedTags.add('IFRAME');
    const removeTags = new Set([
      'BUTTON',
      'EMBED',
      'FORM',
      'INPUT',
      'LINK',
      'META',
      'OBJECT',
      'SCRIPT',
      'SELECT',
      'STYLE',
      'TEXTAREA'
    ]);
    if (!allowTrustedVideoEmbeds) removeTags.add('IFRAME');
    const unwrapTags = new Set(['CENTER', 'FONT', 'MARK', 'SPAN', 'SUB', 'SUP', 'U']);
    const blockWrapperTags = new Set(['ARTICLE', 'ASIDE', 'DIV', 'FOOTER', 'HEADER', 'MAIN', 'SECTION']);
    const blockSelector = 'blockquote,h1,h2,h3,h4,h5,h6,iframe,ol,p,table,ul';
    const replaceTag = (element, tagName) => {
      const replacement = document.createElement(tagName);
      while (element.firstChild) replacement.appendChild(element.firstChild);
      element.replaceWith(replacement);
      return replacement;
    };
    const unwrap = (element) => {
      const parent = element.parentNode;
      if (!parent) return;
      while (element.firstChild) parent.insertBefore(element.firstChild, element);
      element.remove();
    };
    const safeUrl = (url) => url && !/^\s*(?:javascript|data):/i.test(url);
    const trustedVideoEmbedUrl = (value) => {
      const source = String(value || '').trim();
      if (!/^https:\/\//i.test(source)) return '';

      try {
        const url = new URL(source);
        if (url.protocol !== 'https:' || url.username || url.password || url.port) return '';

        const hostname = url.hostname.toLowerCase();
        const isYoutube = new Set([
          'youtube.com',
          'www.youtube.com',
          'youtube-nocookie.com',
          'www.youtube-nocookie.com'
        ]).has(hostname) && /^\/embed\/[A-Za-z0-9_-]{11}\/?$/.test(url.pathname);
        const isVimeo = hostname === 'player.vimeo.com' && /^\/video\/\d+\/?$/.test(url.pathname);
        if (!isYoutube && !isVimeo) return '';

        url.hash = '';
        url.searchParams.delete('autoplay');
        url.searchParams.delete('background');
        return url.toString();
      } catch (error) {
        return '';
      }
    };
    const cleanAttributes = (element) => {
      const tag = element.tagName;
      const href = tag === 'A' ? element.getAttribute('href') : '';
      const src = tag === 'IMG' || tag === 'IFRAME' ? element.getAttribute('src') : '';
      const alt = tag === 'IMG' ? element.getAttribute('alt') : '';
      const title = tag === 'IFRAME' ? element.getAttribute('title')?.trim().slice(0, 160) : '';
      const colspan = /^(?:TD|TH)$/.test(tag) ? element.getAttribute('colspan') : '';
      const rowspan = /^(?:TD|TH)$/.test(tag) ? element.getAttribute('rowspan') : '';
      Array.from(element.attributes).forEach((attribute) => element.removeAttribute(attribute.name));
      if (tag === 'A' && safeUrl(href)) element.setAttribute('href', href);
      if (tag === 'IMG') {
        if (!safeUrl(src)) {
          element.remove();
          return;
        }
        element.setAttribute('src', src);
        if (alt) element.setAttribute('alt', alt);
        element.setAttribute('loading', 'lazy');
        element.setAttribute('decoding', 'async');
      }
      if (tag === 'IFRAME') {
        const trustedSrc = trustedVideoEmbedUrl(src);
        if (!trustedSrc) {
          element.remove();
          return;
        }
        element.setAttribute('src', trustedSrc);
        element.setAttribute('title', title || 'Video player');
        element.setAttribute('loading', 'lazy');
        element.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
        element.setAttribute('allow', 'encrypted-media; picture-in-picture; fullscreen');
        element.setAttribute('allowfullscreen', '');
        element.setAttribute('frameborder', '0');
        element.setAttribute('data-trusted-video-embed', '');
      }
      if (/^(?:TD|TH)$/.test(tag)) {
        if (/^[2-9]$|^1[0-2]$/.test(colspan || '')) element.setAttribute('colspan', colspan);
        if (/^[2-9]$|^1[0-2]$/.test(rowspan || '')) element.setAttribute('rowspan', rowspan);
      }
    };
    const normalizeElement = (element) => {
      if (!element.isConnected) return;
      if (removeTags.has(element.tagName)) {
        element.remove();
        return;
      }

      let current = element;
      if (current.tagName === 'B') current = replaceTag(current, 'strong');
      if (current.tagName === 'I') current = replaceTag(current, 'em');
      if (current.tagName === 'H1') current = replaceTag(current, 'h2');
      if (current.tagName === 'H5' || current.tagName === 'H6') current = replaceTag(current, 'h3');

      if (blockWrapperTags.has(current.tagName)) {
        if (current.querySelector(blockSelector)) {
          unwrap(current);
          return;
        }
        current = replaceTag(current, 'p');
      }

      if (unwrapTags.has(current.tagName) || !allowedTags.has(current.tagName)) {
        unwrap(current);
        return;
      }

      cleanAttributes(current);
    };
    const walk = (node) => {
      Array.from(node.childNodes).forEach((child) => {
        if (child.nodeType === Node.COMMENT_NODE) {
          child.remove();
          return;
        }
        if (child.nodeType !== Node.ELEMENT_NODE) return;
        if (removeTags.has(child.tagName)) {
          child.remove();
          return;
        }
        walk(child);
        normalizeElement(child);
      });
    };
    const removeEmptyBlocks = () => {
      root.querySelectorAll('blockquote,h2,h3,h4,li,p').forEach((element) => {
        if (element.querySelector('iframe, img')) return;
        if (element.textContent.replace(/\u00a0/g, ' ').trim() === '') element.remove();
      });
      root.querySelectorAll('ol,table,tbody,tfoot,thead,tr,ul').forEach((element) => {
        if (element.querySelector('iframe, img')) return;
        if (element.textContent.replace(/\u00a0/g, ' ').trim() === '') element.remove();
      });
    };

    walk(root);
    removeEmptyBlocks();
    root.normalize();
  };
  const saveFocus = (key) => {
    overlayFocus[key] = document.activeElement instanceof HTMLElement ? document.activeElement : null;
  };
  const restoreFocus = (key) => {
    const target = overlayFocus[key];
    overlayFocus[key] = null;
    if (target && document.contains(target) && typeof target.focus === 'function') {
      target.focus({ preventScroll: true });
    }
  };
  const focusOverlay = (container, preferred) => {
    window.requestAnimationFrame(() => {
      const target = preferred || visibleFocusable(container)[0] || container;
      if (target && typeof target.focus === 'function') target.focus({ preventScroll: true });
    });
  };
  const trapOverlayFocus = (event) => {
    if (event.key !== 'Tab') return;
    const overlay = openOverlay();
    if (!overlay) return;
    const focusable = visibleFocusable(overlay);
    if (!focusable.length) {
      event.preventDefault();
      overlay.focus({ preventScroll: true });
      return;
    }
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus({ preventScroll: true });
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus({ preventScroll: true });
    }
  };

  const megaMenuItems = Array.from(document.querySelectorAll('.hdr-nav-item.has-submenu'));
  let megaMenuCloseTimer = 0;
  const setMegaMenuExpanded = (item, expanded) => {
    item.classList.toggle('is-open', expanded);
    item.querySelector('.hdr-nav-link')?.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  };
  const closeMegaMenus = (exceptItem) => {
    megaMenuItems.forEach((item) => {
      if (item !== exceptItem) setMegaMenuExpanded(item, false);
    });
  };
  const openMegaMenu = (item) => {
    window.clearTimeout(megaMenuCloseTimer);
    closeMegaMenus(item);
    setMegaMenuExpanded(item, true);
  };
  const scheduleMegaMenuClose = (item) => {
    window.clearTimeout(megaMenuCloseTimer);
    megaMenuCloseTimer = window.setTimeout(() => {
      if (!item.matches(':hover') && !item.contains(document.activeElement)) {
        setMegaMenuExpanded(item, false);
      }
    }, 360);
  };
  megaMenuItems.forEach((item) => {
    item.addEventListener('pointerenter', () => openMegaMenu(item));
    item.addEventListener('pointerleave', () => scheduleMegaMenuClose(item));
    item.addEventListener('focusin', () => openMegaMenu(item));
    item.addEventListener('focusout', (event) => {
      if (event.relatedTarget instanceof Node && item.contains(event.relatedTarget)) return;
      scheduleMegaMenuClose(item);
    });
  });

  const setMobileNav = (open) => {
    const mobileNav = document.querySelector('[data-mobile-nav]');
    if (!mobileNav) return;
    const wasOpen = mobileNav.classList.contains('open');
    if (open && !wasOpen) saveFocus('mobileNav');
    mobileNav.classList.toggle('open', open);
    mobileNav.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.querySelectorAll('[data-open-mobile-nav]').forEach((button) => {
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    syncBodyLock();
    if (open) {
      focusOverlay(mobileNav, mobileNav);
    } else if (wasOpen) {
      restoreFocus('mobileNav');
    }
  };
  const filterDrawer = document.querySelector('[data-filter-drawer]');
  const filterMask = document.querySelector('.filter-mask');
  const setFilters = (open) => {
    if (!filterDrawer || !filterMask) return;
    const wasOpen = filterDrawer.classList.contains('open');
    if (open && !wasOpen) saveFocus('filters');
    document.querySelectorAll('[data-open-filters]').forEach((button) => {
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    filterDrawer.classList.toggle('open', open);
    filterMask.classList.toggle('open', open);
    filterDrawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (open) {
      filterDrawer.setAttribute('role', 'dialog');
      filterDrawer.setAttribute('aria-modal', 'true');
      filterDrawer.setAttribute('aria-labelledby', 'CollectionFilterTitle');
    } else {
      filterDrawer.removeAttribute('role');
      filterDrawer.removeAttribute('aria-modal');
      filterDrawer.removeAttribute('aria-labelledby');
    }
    syncBodyLock();
    if (open) {
      focusOverlay(filterDrawer);
    } else if (wasOpen) {
      restoreFocus('filters');
    }
  };
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartMask = document.querySelector('.cart-mask');
  const cartBody = document.querySelector('[data-cart-drawer-body]');
  const cartFooter = document.querySelector('[data-cart-drawer-footer]');
  const cartDrawerCount = document.querySelector('[data-cart-drawer-count]');
  const cartDrawerSubtotal = document.querySelector('[data-cart-drawer-subtotal]');
  const cartCountEls = document.querySelectorAll('[data-cart-count]');
  const routesRoot = window.Shopify?.routes?.root || '/';
  const cartUrl = `${routesRoot}cart`;
  const freeShippingThresholdCents = Number(cartDrawer?.dataset.freeShippingThreshold || 0);
  const freeShippingUnlockedMessage = cartDrawer?.dataset.freeShippingUnlocked || 'Free AU shipping unlocked.';
  const freeShippingProgressTemplate = cartDrawer?.dataset.freeShippingProgress || 'Spend [amount] more for free AU shipping.';
  let cartRequestId = 0;
  const setCart = (open) => {
    if (!cartDrawer || !cartMask) return;
    const wasOpen = cartDrawer.classList.contains('open');
    if (open && !wasOpen) saveFocus('cart');
    cartDrawer.classList.toggle('open', open);
    cartMask.classList.toggle('open', open);
    cartDrawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.querySelectorAll('[data-open-cart]').forEach((link) => {
      link.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    syncBodyLock();
    if (open) {
      loadDeferredImagesIn(cartDrawer);
      focusOverlay(cartDrawer);
    } else if (wasOpen) {
      restoreFocus('cart');
    }
  };
  const setCartCount = (itemCount) => {
    cartCountEls.forEach((countEl) => {
      countEl.textContent = itemCount;
      countEl.classList.toggle('is-empty', itemCount === 0);
    });
    document.querySelectorAll('[data-open-cart]').forEach((link) => {
      link.setAttribute('aria-label', `Cart, ${itemCount} ${itemCount === 1 ? 'item' : 'items'}`);
    });
    if (cartDrawerCount) cartDrawerCount.textContent = `${itemCount} ${itemCount === 1 ? 'item' : 'items'}`;
  };
  const formatWithDelimiters = (cents, precision = 2, thousands = ',', decimal = '.') => {
    const number = Number(cents || 0) / 100;
    if (!Number.isFinite(number)) return '0';
    const fixed = number.toFixed(precision);
    const [dollars, remainder] = fixed.split('.');
    const withThousands = dollars.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return precision > 0 ? `${withThousands}${decimal}${remainder}` : withThousands;
  };
  const money = (cents) => {
    const format = document.documentElement.dataset.moneyFormat || '${{amount}}';
    const placeholder = format.match(/\{\{\s*(\w+)\s*\}\}/);
    const token = placeholder?.[1] || 'amount';
    const value = {
      amount: formatWithDelimiters(cents, 2),
      amount_no_decimals: formatWithDelimiters(cents, 0),
      amount_with_comma_separator: formatWithDelimiters(cents, 2, '.', ','),
      amount_no_decimals_with_comma_separator: formatWithDelimiters(cents, 0, '.', ','),
      amount_with_apostrophe_separator: formatWithDelimiters(cents, 2, "'", '.'),
      amount_no_decimals_with_space_separator: formatWithDelimiters(cents, 0, ' '),
      amount_with_space_separator: formatWithDelimiters(cents, 2, ' ', '.'),
      amount_with_period_and_space_separator: formatWithDelimiters(cents, 2, ' ', '.')
    }[token] || formatWithDelimiters(cents, 2);
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  };
  const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  })[char]);
  const imagePlaceholder = 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%221%22 height=%221%22 viewBox=%220 0 1 1%22/%3E';
  const renderCartProgress = (cart) => {
    if (!freeShippingThresholdCents || cart.item_count === 0) return '';
    const remaining = freeShippingThresholdCents - cart.total_price;
    const progress = Math.max(0, Math.min(100, (cart.total_price / freeShippingThresholdCents) * 100));
    const message = remaining > 0
      ? freeShippingProgressTemplate.replace('[amount]', money(remaining))
      : freeShippingUnlockedMessage;

    return `
      <div class="cart-progress" data-cart-progress>
        <p data-cart-progress-message>${escapeHtml(message)}</p>
        <div class="cart-progress-bar" aria-hidden="true">
          <span data-cart-progress-fill style="width: ${progress}%"></span>
        </div>
      </div>
    `;
  };
  const uniqueCartProductIds = (cart) => Array.from(new Set((cart?.items || [])
    .map((item) => String(item.product_id || ''))
    .filter(Boolean)));
  const uniqueCartProductHandles = (cart) => Array.from(new Set((cart?.items || [])
    .map((item) => String(item.handle || ''))
    .filter(Boolean)));
  const renderCartRecommendationsShell = (cart) => `
    <div
      class="cart-recommendations"
      aria-label="Complete your order"
      data-cart-recommendations
      data-accessories-url="${routesRoot}collections/accessories?sort_by=best-selling"
      data-cart-product-ids="${uniqueCartProductIds(cart).map(escapeHtml).join(',')}"
      data-cart-product-handles="${uniqueCartProductHandles(cart).map(escapeHtml).join(',')}"
    >
      <div class="cart-recommendations-hd">
        <p>You may also like</p>
        <div class="cart-recommendations-nav" data-cart-recommendations-nav hidden>
          <button class="cart-recommendations-nav-button cart-recommendations-nav-button--prev" type="button" data-cart-recommendations-prev aria-label="Scroll recommendations left" disabled></button>
          <button class="cart-recommendations-nav-button cart-recommendations-nav-button--next" type="button" data-cart-recommendations-next aria-label="Scroll recommendations right" disabled></button>
        </div>
      </div>
      <div class="cart-recommendations-status" data-cart-recommendations-status>Finding products...</div>
      <div class="cart-recommendations-viewport" data-cart-recommendations-viewport hidden>
        <div class="cart-recommendations-track" data-cart-recommendations-track></div>
      </div>
    </div>
  `;
  const cartRecommendationsCache = new Map();
  const cartAccessoriesCache = new Map();
  const priceToCents = (value) => {
    if (typeof value === 'number') return value;
    if (typeof value !== 'string' || !value.trim()) return null;
    const parsed = Number.parseFloat(value.replace(/,/g, '').replace(/[^0-9.-]/g, ''));
    return Number.isFinite(parsed) ? Math.round(parsed * 100) : null;
  };
  const productImageUrl = (product) => {
    const image = product?.featured_image || product?.image || product?.images?.[0];
    if (!image) return '';
    return typeof image === 'string' ? image : (image.url || image.src || '');
  };
  const productPrice = (product) => {
    if (product?.price_text) return product.price_text;
    if (typeof product?.price_min === 'number') return money(product.price_min);
    if (typeof product?.price === 'number') return money(product.price);
    const variantPrices = Array.isArray(product?.variants)
      ? product.variants
        .map((variant) => priceToCents(variant?.price))
        .filter((price) => price != null)
      : [];
    if (variantPrices.length) return money(Math.min(...variantPrices));
    const priceCents = priceToCents(product?.price_min ?? product?.price);
    if (priceCents != null) return money(priceCents);
    return product?.price || product?.price_min || '';
  };
  const productUrl = (product) => (
    product?.url
      || (product?.handle ? `${routesRoot}products/${encodeURIComponent(product.handle)}` : '#')
  );
  const productHandle = (product) => {
    if (product?.handle) return String(product.handle);
    const url = productUrl(product);
    const match = url.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  };
  const productId = (product) => String(product?.product_id || product?.id || '');
  const productAvailable = (product) => {
    if (product?.available === false) return false;
    if (Array.isArray(product?.variants) && product.variants.length) {
      return product.variants.some((variant) => variant?.available !== false);
    }
    return true;
  };
  const productFirstAvailableVariantId = (product) => {
    if (product?.variant_id) return String(product.variant_id);
    if (product?.selected_or_first_available_variant?.id) return String(product.selected_or_first_available_variant.id);
    if (!Array.isArray(product?.variants) || !product.variants.length) return '';
    const availableVariant = product.variants.find((variant) => variant?.id && variant?.available !== false);
    return String((availableVariant || product.variants.find((variant) => variant?.id))?.id || '');
  };
  const fetchRecommendedProducts = async (productId, intent) => {
    const cacheKey = `${productId}:${intent}`;
    if (cartRecommendationsCache.has(cacheKey)) return cartRecommendationsCache.get(cacheKey);

    const request = fetch(`${routesRoot}recommendations/products.json?product_id=${encodeURIComponent(productId)}&limit=10&intent=${intent}`, {
      headers: { Accept: 'application/json' }
    })
      .then((response) => (response.ok ? response.json() : { products: [] }))
      .then((data) => data.products || [])
      .catch(() => []);
    cartRecommendationsCache.set(cacheKey, request);
    return request;
  };
  const parseAccessoryProducts = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return Array.from(doc.querySelectorAll('.pcard')).map((card) => {
      const link = card.querySelector('.pcard-link');
      const image = card.querySelector('.prod-photo');
      const href = link?.getAttribute('href') || '';
      const handleMatch = href.match(/\/products\/([^/?#]+)/);
      const handle = handleMatch ? decodeURIComponent(handleMatch[1]) : '';
      const soldOut = Array.from(card.querySelectorAll('.pcard-tag'))
        .some((tag) => /sold out/i.test(tag.textContent || ''));
      const parsedProductId = card.dataset.productId || '';

      return {
        id: parsedProductId || (handle ? `handle:${handle}` : href),
        product_id: parsedProductId,
        variant_id: card.dataset.variantId || '',
        handle,
        url: href || '#',
        title: card.querySelector('.pcard-name')?.textContent.trim() || link?.textContent.trim() || '',
        vendor: card.querySelector('.pcard-brand')?.textContent.trim() || '',
        price_text: card.querySelector('.pcard-price')?.textContent.replace(/\s+/g, ' ').trim() || '',
        image: image?.currentSrc || image?.src || image?.dataset?.src || image?.getAttribute('src') || '',
        available: !soldOut
      };
    }).filter((product) => product.title && product.url);
  };
  const fetchAccessoryProducts = async (url) => {
    if (!url) return [];
    if (cartAccessoriesCache.has(url)) return cartAccessoriesCache.get(url);

    const request = fetch(url, {
      headers: { Accept: 'text/html' }
    })
      .then((response) => (response.ok ? response.text() : ''))
      .then((html) => (html ? parseAccessoryProducts(html) : []))
      .catch(() => []);
    cartAccessoriesCache.set(url, request);
    return request;
  };
  const collectCartRecommendations = async (productIds, accessoriesUrl = '', cartProductHandles = []) => {
    const sourceIds = productIds.slice(0, 3);
    const cartProductSet = new Set(productIds);
    const cartHandleSet = new Set(cartProductHandles);
    const seen = new Set(cartProductSet);
    const seenHandles = new Set(cartHandleSet);
    const products = [];

    if (accessoriesUrl) {
      const accessories = await fetchAccessoryProducts(accessoriesUrl);
      accessories.forEach((product) => {
        const id = String(product.id || '');
        const handle = productHandle(product);
        if (!id || seen.has(id) || (handle && seenHandles.has(handle)) || !productAvailable(product)) return;
        seen.add(id);
        if (handle) seenHandles.add(handle);
        products.push(product);
      });
      if (products.length) return products.slice(0, 8);
    }

    for (const intent of ['complementary', 'related']) {
      for (const productId of sourceIds) {
        const recommendations = await fetchRecommendedProducts(productId, intent);
        recommendations.forEach((product) => {
          const id = String(product.id || '');
          const handle = productHandle(product);
          if (!id || seen.has(id) || (handle && seenHandles.has(handle)) || !productAvailable(product)) return;
          seen.add(id);
          if (handle) seenHandles.add(handle);
          products.push(product);
        });
        if (products.length >= 8) return products.slice(0, 8);
      }
    }

    return products.slice(0, 8);
  };
  const renderCartRecommendationCard = (product) => {
    const imageUrl = productImageUrl(product);
    const price = productPrice(product);
    const id = productId(product);
    const handle = productHandle(product);
    const url = productUrl(product);
    const variantId = productFirstAvailableVariantId(product);
    const canAdd = Boolean(variantId && productAvailable(product));
    const image = imageUrl
      ? `<img class="prod-photo" src="${escapeHtml(imageUrl)}" alt="${escapeHtml(product.title)}" loading="lazy" decoding="async">`
      : `<div class="prod-img" role="img" aria-label="${escapeHtml(product.title)}"></div>`;
    const addButton = canAdd
      ? `
        <button
          class="cart-recommendation-add"
          type="button"
          data-cart-recommendation-add
          data-variant-id="${escapeHtml(variantId)}"
          data-product-id="${escapeHtml(id)}"
          data-product-handle="${escapeHtml(handle)}"
          aria-label="Add ${escapeHtml(product.title)} to cart"
          title="Add to cart"
        >+</button>
        <span class="cart-recommendation-add-spinner" aria-hidden="true"></span>
      `
      : '';

    return `
      <article
        class="cart-recommendation-card"
        data-cart-recommendation-card
        data-product-url="${escapeHtml(url)}"
        data-product-id="${escapeHtml(id)}"
        data-product-handle="${escapeHtml(handle)}"
      >
        <a class="cart-recommendation-link" href="${escapeHtml(url)}" aria-label="View ${escapeHtml(product.title)}">
          <span class="cart-recommendation-media">
            ${image}
          </span>
          <span class="cart-recommendation-info">
            ${product.vendor ? `<span class="cart-recommendation-vendor">${escapeHtml(product.vendor)}</span>` : ''}
            <span class="cart-recommendation-title">${escapeHtml(product.title)}</span>
            ${price ? `<span class="cart-recommendation-price">${escapeHtml(price)}</span>` : ''}
          </span>
        </a>
        ${canAdd ? `
        <span class="cart-recommendation-action">
          ${addButton}
        </span>
        ` : ''}
      </article>
    `;
  };
  const hideCartRecommendationProduct = (productIdValue = '', handle = '') => {
    const productIdKey = String(productIdValue || '');
    const handleKey = String(handle || '');
    document.querySelectorAll('[data-cart-recommendation-card]').forEach((card) => {
      const matchesProductId = productIdKey && card.dataset.productId === productIdKey;
      const matchesHandle = handleKey && card.dataset.productHandle === handleKey;
      if (!matchesProductId && !matchesHandle) return;

      const container = card.closest('[data-cart-recommendations]');
      card.remove();
      const hasCards = container?.querySelector('[data-cart-recommendation-card]');
      if (container && !hasCards) container.hidden = true;
    });
  };
  const addCartRecommendation = async (button) => {
    const variantId = button?.dataset.variantId;
    if (!variantId || button.disabled) return;

    const card = button.closest('[data-cart-recommendation-card]');
    const productIdValue = button.dataset.productId || card?.dataset.productId || '';
    const handle = button.dataset.productHandle || card?.dataset.productHandle || '';
    const status = button.closest('[data-cart-recommendations]')?.querySelector('[data-cart-recommendations-status]');
    const previousCount = Number(cartCountEls[0]?.textContent || 0);

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    card?.classList.add('is-adding');
    if (status) status.hidden = true;

    try {
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      const response = await fetch(`${cartUrl}/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      });
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || 'Could not add to cart');
      }
      setCartCount(previousCount + 1);
      hideCartRecommendationProduct(productIdValue, handle);
      fetchCart().catch(() => {});
    } catch (error) {
      card?.classList.remove('is-adding');
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if (status) {
        status.textContent = error.message || 'Could not add to cart. Please try again.';
        status.hidden = false;
      }
    }
  };
  const setupCartRecommendationScroller = (container) => {
    if (container.dataset.scrollerReady === 'true') return;
    container.dataset.scrollerReady = 'true';

    const viewport = container.querySelector('[data-cart-recommendations-viewport]');
    if (!viewport) return;

    const nav = container.querySelector('[data-cart-recommendations-nav]');
    const previousButton = container.querySelector('[data-cart-recommendations-prev]');
    const nextButton = container.querySelector('[data-cart-recommendations-next]');
    let isDragging = false;
    let didDrag = false;
    let scrollControlFrame = 0;
    let startX = 0;
    let startLeft = 0;
    const canScroll = () => viewport.scrollWidth > viewport.clientWidth + 4;
    const scheduleScrollControlUpdate = () => {
      if (scrollControlFrame) return;
      scrollControlFrame = window.requestAnimationFrame(() => {
        scrollControlFrame = 0;
        const maxLeft = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
        const hasOverflow = canScroll();
        if (nav) nav.hidden = !hasOverflow;
        if (previousButton) previousButton.disabled = !hasOverflow || viewport.scrollLeft <= 2;
        if (nextButton) nextButton.disabled = !hasOverflow || viewport.scrollLeft >= maxLeft - 2;
      });
    };
    const scrollRecommendations = (direction) => {
      if (!canScroll()) return;
      viewport.scrollBy({
        behavior: 'smooth',
        left: direction * Math.max(160, Math.floor(viewport.clientWidth * 0.82)),
      });
      window.setTimeout(scheduleScrollControlUpdate, 260);
    };

    previousButton?.addEventListener('click', (event) => {
      event.preventDefault();
      scrollRecommendations(-1);
    });
    nextButton?.addEventListener('click', (event) => {
      event.preventDefault();
      scrollRecommendations(1);
    });
    viewport.addEventListener('scroll', scheduleScrollControlUpdate, { passive: true });
    window.addEventListener('resize', scheduleScrollControlUpdate);

    viewport.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || viewport.scrollWidth <= viewport.clientWidth + 4) return;
      isDragging = true;
      didDrag = false;
      startX = event.clientX;
      startLeft = viewport.scrollLeft;
      viewport.classList.add('is-dragging');
      viewport.setPointerCapture(event.pointerId);
    });
    viewport.addEventListener('pointermove', (event) => {
      if (!isDragging) return;
      const delta = event.clientX - startX;
      if (Math.abs(delta) > 3) didDrag = true;
      viewport.scrollLeft = startLeft - delta;
      event.preventDefault();
    });
    const endDrag = () => {
      if (!isDragging) return;
      isDragging = false;
      viewport.classList.remove('is-dragging');
      window.setTimeout(() => {
        didDrag = false;
      }, 0);
    };
    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('lostpointercapture', endDrag);
    viewport.addEventListener('click', (event) => {
      if (!didDrag) return;
      event.preventDefault();
      event.stopPropagation();
    });
    viewport.addEventListener('focusin', (event) => {
      const focusedCard = event.target instanceof Element
        ? event.target.closest('[data-cart-recommendation-card]')
        : null;
      if (!focusedCard) return;

      const cardRect = focusedCard.getBoundingClientRect();
      const viewportRect = viewport.getBoundingClientRect();
      const inset = 8;

      if (cardRect.left < viewportRect.left + inset) {
        viewport.scrollBy({ behavior: 'smooth', left: cardRect.left - viewportRect.left - inset });
      } else if (cardRect.right > viewportRect.right - inset) {
        viewport.scrollBy({
          behavior: 'smooth',
          left: cardRect.right - viewportRect.right + inset,
        });
      }

      window.setTimeout(scheduleScrollControlUpdate, 260);
    });
    scheduleScrollControlUpdate();
  };
  const hydrateCartRecommendations = async (scope = document) => {
    const containers = Array.from(scope.querySelectorAll('[data-cart-recommendations]'))
      .filter((container) => container.dataset.loaded !== 'true');
    if (!containers.length) return;

    await Promise.all(containers.map(async (container) => {
      container.dataset.loaded = 'true';
      const status = container.querySelector('[data-cart-recommendations-status]');
      const viewport = container.querySelector('[data-cart-recommendations-viewport]');
      const track = container.querySelector('[data-cart-recommendations-track]');
      const productIds = (container.dataset.cartProductIds || '')
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean);
      const cartProductHandles = (container.dataset.cartProductHandles || '')
        .split(',')
        .map((handle) => handle.trim())
        .filter(Boolean);
      const accessoriesUrl = container.dataset.accessoriesUrl || `${routesRoot}collections/accessories?sort_by=best-selling`;

      if (!productIds.length || !track || !viewport) {
        container.hidden = true;
        return;
      }

      const products = await collectCartRecommendations(
        Array.from(new Set(productIds)),
        accessoriesUrl,
        Array.from(new Set(cartProductHandles))
      );
      if (!products.length) {
        container.hidden = true;
        return;
      }

      track.innerHTML = products.map(renderCartRecommendationCard).join('');
      if (status) status.hidden = true;
      viewport.hidden = false;
      setupCartRecommendationScroller(container);
    }));
  };
  const renderCartLine = (item) => {
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : item.vendor;
    const imageSrc = escapeHtml(item.image);
    const image = item.image
      ? `<img class="cart-line-photo" src="${imagePlaceholder}" data-defer-image data-src="${imageSrc}" alt="${escapeHtml(item.product_title)}" loading="eager" fetchpriority="low" decoding="async" width="220" height="275">`
      : '<div class="prod-img" role="img" style="aspect-ratio: 4 / 5" aria-label="Product image placeholder"></div>';
    const properties = item.properties
      ? Object.entries(item.properties)
        .filter(([name, value]) => value && !name.startsWith('_'))
        .map(([name, value]) => `
            <div class="cart-line-property">
              <span>${escapeHtml(name)}</span>
              <span>${escapeHtml(value)}</span>
            </div>
          `)
        .join('')
      : '';
    const quantityLabel = `Quantity for ${item.product_title}`;

    return `
        <div class="cart-line" data-cart-line-key="${escapeHtml(item.key)}">
          <a class="cart-line-media" href="${item.url}">${image}</a>
          <div class="cart-line-info">
            <a class="cart-line-name" href="${item.url}">${escapeHtml(item.product_title)}</a>
            <div class="cart-line-variant">${escapeHtml(variant)}</div>
            ${properties ? `<div class="cart-line-properties">${properties}</div>` : ''}
            <div class="cart-line-bottom">
              <div class="cart-line-qty">
                <button type="button" data-cart-drawer-qty-minus aria-label="Decrease ${escapeHtml(item.product_title)} quantity">-</button>
                <input class="cart-qty-input" type="number" min="0" value="${item.quantity}" aria-label="${escapeHtml(quantityLabel)}" data-cart-drawer-qty-input>
                <button type="button" data-cart-drawer-qty-plus aria-label="Increase ${escapeHtml(item.product_title)} quantity">+</button>
              </div>
              <span class="cart-line-price">${money(item.final_line_price)}</span>
          </div>
          <a class="cart-line-remove" href="${cartUrl}/change?id=${encodeURIComponent(item.key)}&quantity=0" data-cart-drawer-remove>Remove</a>
        </div>
      </div>
    `;
  };
  const renderCart = (cart) => {
    setCartCount(cart.item_count);
    if (cartDrawerSubtotal) cartDrawerSubtotal.textContent = money(cart.total_price);
    if (cartFooter) cartFooter.hidden = cart.item_count === 0;
    if (!cartBody) return;
    cartBody.innerHTML = cart.item_count
      ? `${renderCartProgress(cart)}${cart.items.map(renderCartLine).join('')}${renderCartRecommendationsShell(cart)}`
      : `
        <div class="cart-empty">
          <h3>Your cart is empty</h3>
          <p>Surfboards, wetsuits, wax, fins — pick something out and we'll wrap it up.</p>
          <a class="btn" href="${routesRoot}collections/all?filter.v.availability=1">Shop the range</a>
        </div>
      `;
    startDeferredImageLoading(cartBody);
    if (cartDrawer?.classList.contains('open')) loadDeferredImagesIn(cartBody);
    hydrateCartRecommendations(cartBody);
  };
  const renderCartStatus = (message, isError = false) => {
    if (cartFooter) cartFooter.hidden = true;
    if (!cartBody) return;
    cartBody.innerHTML = `
      <div class="cart-status${isError ? ' cart-status-error' : ''}" role="status" aria-live="polite">
        ${isError ? '' : '<span class="cart-status-spinner" aria-hidden="true"></span>'}
        <span>${escapeHtml(message)}</span>
      </div>
    `;
  };
  const fetchCart = async () => {
    const requestId = ++cartRequestId;
    const response = await fetch(`${cartUrl}.js`, {
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Could not load cart');
    const cart = await response.json();
    if (requestId === cartRequestId) renderCart(cart);
    return cart;
  };
  const updateCartLine = async (key, quantity, line) => {
    if (!key) return null;
    const requestId = ++cartRequestId;
    line?.classList.add('is-updating');
    line?.querySelectorAll('button, input').forEach((control) => {
      control.disabled = true;
    });

    const response = await fetch(`${cartUrl}/change.js`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: Math.max(0, Number(quantity || 0))
      })
    });
    if (!response.ok) throw new Error('Could not update cart');
    const cart = await response.json();
    if (requestId === cartRequestId) renderCart(cart);
    return cart;
  };
  hydrateCartRecommendations();
  const searchSheet = document.querySelector('[data-search-sheet]');
  const searchMask = document.querySelector('.search-mask');
  const searchInput = document.querySelector('[data-search-input]');
  const searchSuggest = document.querySelector('[data-search-suggest]');
  const searchLive = document.querySelector('[data-search-live]');
  const searchResults = document.querySelector('[data-search-results]');
  const searchViewAll = document.querySelector('[data-search-view-all]');
  const searchEmpty = document.querySelector('[data-search-empty]');
  const setSearch = (open) => {
    if (!searchSheet || !searchMask) return;
    const wasOpen = searchSheet.classList.contains('open');
    if (open && !wasOpen) saveFocus('search');
    searchSheet.classList.toggle('open', open);
    searchMask.classList.toggle('open', open);
    searchSheet.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.querySelectorAll('[data-open-search]').forEach((button) => {
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    syncBodyLock();
    if (open) {
      focusOverlay(searchSheet, searchInput);
    } else if (wasOpen) {
      restoreFocus('search');
    }
  };
  let predictiveSearchTimer = null;
  let predictiveSearchRequestId = 0;
  const predictiveImageUrl = (product) => {
    const image = product?.featured_image || product?.image;
    if (!image) return '';
    return typeof image === 'string' ? image : (image.url || image.src || '');
  };
  const predictivePriceCents = (value) => {
    if (typeof value === 'number') return value;
    if (typeof value !== 'string' || value.trim() === '') return null;
    const parsed = Number.parseFloat(value.replace(/,/g, '').replace(/[^0-9.-]/g, ''));
    return Number.isFinite(parsed) ? Math.round(parsed * 100) : null;
  };
  const predictivePriceMarkup = (product) => {
    const priceCents = predictivePriceCents(product?.price_min ?? product?.price);
    const compareCents = predictivePriceCents(product?.compare_at_price_min ?? product?.compare_at_price);
    if (priceCents == null) {
      const fallback = product?.price || product?.price_min || '';
      return fallback ? `<span>${escapeHtml(fallback)}</span>` : '';
    }
    const hasRange = product?.price_min && product?.price_max && product.price_min !== product.price_max;
    const prefix = hasRange ? 'From ' : '';
    if (compareCents != null && compareCents > priceCents) {
      return `
        <span class="search-result-price-current">${prefix}${money(priceCents)}</span>
        <span class="search-result-price-was">${money(compareCents)}</span>
      `;
    }
    return `<span>${prefix}${money(priceCents)}</span>`;
  };
  const setPredictiveState = ({ active = false, loading = false, empty = false } = {}) => {
    if (!searchLive || !searchSuggest) return;
    searchLive.hidden = !active;
    searchSuggest.hidden = active;
    if (searchEmpty) searchEmpty.hidden = !empty;
    if (searchResults && loading) {
      searchResults.innerHTML = '<li class="search-loading">Searching products...</li>';
    }
  };
  const resetPredictiveSearch = () => {
    window.clearTimeout(predictiveSearchTimer);
    predictiveSearchRequestId += 1;
    if (searchResults) searchResults.innerHTML = '';
    if (searchViewAll) searchViewAll.hidden = true;
    setPredictiveState({ active: false });
  };
  const renderPredictiveSearch = (products, query) => {
    if (!searchResults || !searchViewAll) return;
    const trimmedQuery = query.trim();
    searchViewAll.href = `${routesRoot}search?type=product&q=${encodeURIComponent(trimmedQuery)}`;
    searchViewAll.hidden = products.length === 0;
    setPredictiveState({ active: true, empty: products.length === 0 });
    searchResults.innerHTML = products.map((product) => {
      const imageUrl = predictiveImageUrl(product);
      const price = predictivePriceMarkup(product);
      const productType = product.type || product.product_type || '';
      const productUrl = product.url || `${routesRoot}search?type=product&q=${encodeURIComponent(product.title || trimmedQuery)}`;
      const image = imageUrl
        ? `<img class="prod-photo" src="${escapeHtml(imageUrl)}" alt="${escapeHtml(product.title)}" loading="eager" decoding="async">`
        : `<div class="prod-img" role="img" aria-label="${escapeHtml(product.title)}"></div>`;
      return `
        <li>
          <a class="search-result" href="${escapeHtml(productUrl)}">
            <span class="search-result-media">${image}</span>
            <span class="search-result-info">
              ${product.vendor ? `<span class="search-result-brand">${escapeHtml(product.vendor)}</span>` : ''}
              <span class="search-result-name">${escapeHtml(product.title)}</span>
              ${productType ? `<span class="search-result-meta">${escapeHtml(productType)}</span>` : ''}
            </span>
            ${price ? `<span class="search-result-price">${price}</span>` : ''}
          </a>
        </li>
      `;
    }).join('');
  };
  const fetchPredictiveSearch = async (query, requestId) => {
    const url = `${routesRoot}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
    try {
      const response = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Predictive search failed');
      const data = await response.json();
      if (requestId !== predictiveSearchRequestId) return;
      renderPredictiveSearch(data?.resources?.results?.products || [], query);
    } catch (error) {
      if (requestId !== predictiveSearchRequestId) return;
      setPredictiveState({ active: true, empty: true });
      if (searchResults) searchResults.innerHTML = '';
      if (searchViewAll) {
        searchViewAll.href = `${routesRoot}search?type=product&q=${encodeURIComponent(query.trim())}`;
        searchViewAll.hidden = false;
      }
    }
  };
  searchInput?.addEventListener('input', () => {
    const query = searchInput.value.trim();
    window.clearTimeout(predictiveSearchTimer);
    if (query.length < 2) {
      resetPredictiveSearch();
      return;
    }
    const requestId = ++predictiveSearchRequestId;
    setPredictiveState({ active: true, loading: true });
    if (searchViewAll) {
      searchViewAll.href = `${routesRoot}search?type=product&q=${encodeURIComponent(query)}`;
      searchViewAll.hidden = false;
    }
    predictiveSearchTimer = window.setTimeout(() => {
      fetchPredictiveSearch(query, requestId);
    }, 180);
  });

  const newsletterPopup = document.querySelector('[data-newsletter-popup]');
  const newsletterPanel = newsletterPopup?.querySelector('.newsletter-popup-panel');
  const newsletterInput = newsletterPopup?.querySelector('[data-newsletter-popup-name], [data-newsletter-popup-email]');
  const newsletterFeedback = newsletterPopup?.querySelector('[data-newsletter-popup-feedback]');
  const newsletterDismissedKey = 'kfsys-newsletter-popup-dismissed-v2';
  const newsletterSeenKey = 'kfsys-newsletter-popup-seen-v2';
  const newsletterDismissMs = 1000 * 60 * 60 * 24 * 14;
  const storageGet = (storage, key) => {
    try {
      return storage?.getItem(key);
    } catch (error) {
      return null;
    }
  };
  const storageSet = (storage, key, value) => {
    try {
      storage?.setItem(key, value);
    } catch (error) {
      // Storage can be unavailable in private browsing modes.
    }
  };
  const isNewsletterDismissed = () => {
    const value = Number(storageGet(window.localStorage, newsletterDismissedKey) || 0);
    return value > 0 && Date.now() - value < newsletterDismissMs;
  };
  const persistNewsletterDismissal = () => {
    storageSet(window.localStorage, newsletterDismissedKey, String(Date.now()));
  };
  const setNewsletterPopup = (open, options = {}) => {
    if (!newsletterPopup || !newsletterPanel) return;
    const wasOpen = newsletterPopup.classList.contains('open');
    if (open && !wasOpen) saveFocus('newsletter');
    newsletterPopup.classList.toggle('open', open);
    newsletterPopup.setAttribute('aria-hidden', open ? 'false' : 'true');
    syncBodyLock();
    if (open) {
      focusOverlay(newsletterPanel, newsletterInput);
    } else if (wasOpen) {
      if (options.persist !== false) persistNewsletterDismissal();
      restoreFocus('newsletter');
    }
  };
  if (newsletterPopup) {
    newsletterPopup.addEventListener('click', (event) => {
      if (!event.target.closest('[data-newsletter-popup-close]')) return;
      event.preventDefault();
      setNewsletterPopup(false);
    });
    newsletterPopup.querySelector('[data-newsletter-popup-form]')?.addEventListener('submit', persistNewsletterDismissal);

    const params = new URLSearchParams(window.location.search);
    const forceNewsletter = ['1', 'true', 'show'].includes((params.get('newsletter') || params.get('newsletter_popup') || '').toLowerCase());
    const suppressNewsletter = !forceNewsletter && (params.has('customer_posted') || isNewsletterDismissed() || storageGet(window.sessionStorage, newsletterSeenKey) === 'true');
    if (newsletterFeedback) {
      setNewsletterPopup(true, { persist: false });
      window.setTimeout(() => newsletterFeedback.focus(), 0);
    } else if (!suppressNewsletter) {
      window.setTimeout(() => {
        if (openOverlay()) return;
        storageSet(window.sessionStorage, newsletterSeenKey, 'true');
        setNewsletterPopup(true);
      }, forceNewsletter ? 250 : 12000);
    }
  }

  const smilePanelTimeoutMs = 7000;
  const smileRewardsDeepLink = 'home';
  const smileLauncherSelector = [
    '.smile-launcher-frame-container',
    '#smile-ui-lite-launcher-frame-container',
    '#smile-ui-launcher-frame-container',
    '[id^="smile-ui"][id*="launcher-frame-container"]',
    '[class*="smile"][class*="launcher-frame-container"]'
  ].join(',');
  const smilePanelSelector = [
    '.smile-panel-frame-container',
    '#smile-ui-lite-panel-frame-container',
    '#smile-ui-panel-frame-container',
    '[id^="smile-ui"][id*="panel-frame-container"]',
    '[class*="smile"][class*="panel-frame-container"]'
  ].join(',');
	  let smilePanelPollTimer = null;
	  let smilePanelLoadedHandler = null;
	  let smileWidgetSyncFrame = 0;
	  const smileMobilePanelQuery = window.matchMedia('(max-width: 640px)');
	  const setImportantStyle = (element, property, value) => {
	    element.style.setProperty(property, value, 'important');
	  };
	  const clearInlineStyle = (element, property) => {
	    element.style.removeProperty(property);
	  };
	  const setSmilePanelIframeBox = (panel, constrained) => {
	    panel.querySelectorAll('iframe').forEach((iframe) => {
	      if (constrained) {
	        setImportantStyle(iframe, 'width', '100%');
	        setImportantStyle(iframe, 'max-width', '100%');
	        setImportantStyle(iframe, 'height', '100%');
	        setImportantStyle(iframe, 'max-height', '100%');
	      } else {
	        ['width', 'max-width', 'height', 'max-height'].forEach((property) => clearInlineStyle(iframe, property));
	      }
	    });
	  };
	  const syncSmileRewardsWidget = () => {
	    document.querySelectorAll(smileLauncherSelector).forEach((launcher) => {
	      launcher.setAttribute('aria-hidden', 'true');
	      setImportantStyle(launcher, 'display', 'none');
	      setImportantStyle(launcher, 'visibility', 'hidden');
      setImportantStyle(launcher, 'pointer-events', 'none');
	    });

	    document.querySelectorAll(smilePanelSelector).forEach((panel) => {
	      setImportantStyle(panel, 'position', 'fixed');
	      setImportantStyle(panel, 'z-index', '2147482999');
	      if (smileMobilePanelQuery.matches) {
	        const viewport = window.visualViewport;
	        const viewportWidth = Math.floor(viewport?.width || window.innerWidth || document.documentElement.clientWidth || 360);
	        const viewportHeight = Math.floor(viewport?.height || window.innerHeight || document.documentElement.clientHeight || 640);
	        const panelWidth = Math.max(280, viewportWidth - 16);
	        const panelHeight = Math.max(360, viewportHeight - 16);
	        setImportantStyle(panel, 'top', '8px');
	        setImportantStyle(panel, 'right', 'auto');
	        setImportantStyle(panel, 'bottom', 'auto');
	        setImportantStyle(panel, 'left', '8px');
	        setImportantStyle(panel, 'width', `${panelWidth}px`);
	        setImportantStyle(panel, 'max-width', `${panelWidth}px`);
	        setImportantStyle(panel, 'height', `${panelHeight}px`);
	        setImportantStyle(panel, 'max-height', `${panelHeight}px`);
	        setImportantStyle(panel, 'overflow', 'hidden');
	        setSmilePanelIframeBox(panel, true);
	      } else {
	        const viewport = window.visualViewport;
	        const viewportWidth = Math.floor(viewport?.width || window.innerWidth || document.documentElement.clientWidth || 1024);
	        const viewportHeight = Math.floor(viewport?.height || window.innerHeight || document.documentElement.clientHeight || 720);
	        const panelWidth = Math.max(280, Math.min(360, viewportWidth - 32));
	        const panelHeight = Math.max(320, Math.min(600, viewportHeight - 32));
	        setImportantStyle(panel, 'top', 'auto');
	        setImportantStyle(panel, 'right', 'max(16px, env(safe-area-inset-right, 0px))');
	        setImportantStyle(panel, 'bottom', 'max(16px, env(safe-area-inset-bottom, 0px))');
	        setImportantStyle(panel, 'left', 'auto');
	        setImportantStyle(panel, 'width', `${panelWidth}px`);
	        setImportantStyle(panel, 'max-width', `${panelWidth}px`);
	        setImportantStyle(panel, 'height', `${panelHeight}px`);
	        setImportantStyle(panel, 'max-height', `${panelHeight}px`);
	        setImportantStyle(panel, 'overflow', 'hidden');
	        setSmilePanelIframeBox(panel, true);
	      }
	    });
	  };
  const scheduleSmileRewardsWidgetSync = () => {
    if (smileWidgetSyncFrame) return;
    smileWidgetSyncFrame = window.requestAnimationFrame(() => {
      smileWidgetSyncFrame = 0;
      syncSmileRewardsWidget();
    });
  };
  const smilePanelOptions = (deepLink) => deepLink ? { deep_link: deepLink } : undefined;
  const openSmileRewardsPanel = (deepLink = smileRewardsDeepLink) => {
    if (typeof window.SmileUI?.openPanel !== 'function') return false;

    try {
      syncSmileRewardsWidget();
      window.SmileUI.openPanel(smilePanelOptions(deepLink));
      scheduleSmileRewardsWidgetSync();
      window.setTimeout(scheduleSmileRewardsWidgetSync, 250);
      return true;
    } catch (error) {
      return false;
    }
  };
  const rewardsFallbackUrl = (fallbackUrl, deepLink) => {
    if (!fallbackUrl || !deepLink) return fallbackUrl;

    try {
      const url = new URL(fallbackUrl, window.location.href);
      url.searchParams.set('smile_deep_link', deepLink);
      return url.toString();
    } catch (error) {
      return fallbackUrl;
    }
  };
  const clearSmilePanelWait = () => {
    window.clearTimeout(smilePanelPollTimer);
    smilePanelPollTimer = null;
    if (smilePanelLoadedHandler) {
      document.removeEventListener('smile-ui-loaded', smilePanelLoadedHandler);
      smilePanelLoadedHandler = null;
    }
  };
  const releaseThirdPartyGate = () => {
    if (window.__thirdPartyGate?.ready) return;
    if (typeof window.__thirdPartyGate?.release !== 'function') return;

    try {
      window.__thirdPartyGate.release();
    } catch (error) {
      // Keep the rewards link fallback available if the gate cannot release.
    }
  };
  const waitForSmileRewardsPanel = (fallbackUrl, deepLink = smileRewardsDeepLink) => {
    const deadline = Date.now() + smilePanelTimeoutMs;
    const panelFallbackUrl = rewardsFallbackUrl(fallbackUrl, deepLink);
    clearSmilePanelWait();

    const poll = () => {
      if (openSmileRewardsPanel(deepLink)) {
        clearSmilePanelWait();
        return;
      }
      if (Date.now() >= deadline) {
        clearSmilePanelWait();
        if (panelFallbackUrl) window.location.assign(panelFallbackUrl);
        return;
      }
      smilePanelPollTimer = window.setTimeout(poll, 100);
    };

    smilePanelLoadedHandler = () => {
      if (openSmileRewardsPanel(deepLink)) clearSmilePanelWait();
    };
    document.addEventListener('smile-ui-loaded', smilePanelLoadedHandler);
    poll();
  };
	  syncSmileRewardsWidget();
	  document.addEventListener('smile-ui-loaded', scheduleSmileRewardsWidgetSync);
	  window.addEventListener('thirdparty:ready', scheduleSmileRewardsWidgetSync);
	  if (typeof smileMobilePanelQuery.addEventListener === 'function') {
	    smileMobilePanelQuery.addEventListener('change', scheduleSmileRewardsWidgetSync);
	  } else if (typeof smileMobilePanelQuery.addListener === 'function') {
	    smileMobilePanelQuery.addListener(scheduleSmileRewardsWidgetSync);
	  }
	  window.visualViewport?.addEventListener('resize', scheduleSmileRewardsWidgetSync);
	  if (window.MutationObserver && document.body) {
	    const smileWidgetObserver = new MutationObserver(scheduleSmileRewardsWidgetSync);
	    smileWidgetObserver.observe(document.body, { childList: true, subtree: true });
	  }

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const rewardsTrigger = target.closest('[data-rewards-trigger]');
    if (rewardsTrigger) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      event.preventDefault();
      const deepLink = rewardsTrigger.dataset.smileDeepLink || smileRewardsDeepLink;
      setMobileNav(false);
      setFilters(false);
      setCart(false);
      setSearch(false);
      if (!openSmileRewardsPanel(deepLink)) {
        releaseThirdPartyGate();
        waitForSmileRewardsPanel(rewardsTrigger.href, deepLink);
      }
      return;
    }

    const cartQtyButton = target.closest('[data-cart-drawer-qty-minus], [data-cart-drawer-qty-plus]');
    if (cartQtyButton) {
      event.preventDefault();
      const line = cartQtyButton.closest('[data-cart-line-key]');
      const input = line?.querySelector('[data-cart-drawer-qty-input]');
      if (!line || !input) return;
      const delta = cartQtyButton.hasAttribute('data-cart-drawer-qty-plus') ? 1 : -1;
      const nextQuantity = Math.max(0, Number(input.value || 0) + delta);
      input.value = nextQuantity;
      updateCartLine(line.dataset.cartLineKey, nextQuantity, line)
        .catch(() => renderCartStatus('Could not update cart. Please try again.', true));
      return;
    }
    const cartRemove = target.closest('[data-cart-drawer-remove]');
    if (cartRemove) {
      event.preventDefault();
      const line = cartRemove.closest('[data-cart-line-key]');
      updateCartLine(line?.dataset.cartLineKey, 0, line)
        .catch(() => renderCartStatus('Could not update cart. Please try again.', true));
      return;
    }
    const recommendationAdd = target.closest('[data-cart-recommendation-add]');
    if (recommendationAdd) {
      event.preventDefault();
      event.stopPropagation();
      addCartRecommendation(recommendationAdd);
      return;
    }
    if (target.closest('[data-open-mobile-nav]')) {
      event.preventDefault();
      setMobileNav(true);
      return;
    }
    if (target.closest('[data-close-mobile-nav]')) {
      event.preventDefault();
      setMobileNav(false);
      return;
    }
    if (target.closest('[data-open-filters]')) {
      event.preventDefault();
      setMobileNav(false);
      setSearch(false);
      setCart(false);
      setFilters(true);
      return;
    }
    if (target.closest('[data-close-filters]')) {
      event.preventDefault();
      setFilters(false);
      return;
    }
    if (target.closest('[data-open-cart]')) {
      event.preventDefault();
      setMobileNav(false);
      setFilters(false);
      setSearch(false);
      setCart(true);
      renderCartStatus('Loading cart');
      fetchCart().catch(() => renderCartStatus('Could not load cart. Please try again.', true));
      return;
    }
    if (target.closest('[data-close-cart]')) {
      event.preventDefault();
      setCart(false);
      return;
    }
    if (target.closest('[data-open-search]')) {
      event.preventDefault();
      setMobileNav(false);
      setFilters(false);
      setCart(false);
      setSearch(true);
      return;
    }
    if (target.closest('[data-close-search]')) {
      event.preventDefault();
      setSearch(false);
    }
  }, true);
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented) return;
    const target = event.target instanceof Element ? event.target : null;
    if (!target || target.closest('[data-cart-recommendation-add], a[href]')) return;

    const recommendationCard = target.closest('[data-cart-recommendation-card]');
    const url = recommendationCard?.dataset.productUrl;
    if (!url) return;

    event.preventDefault();
    window.location.href = url;
  });
  document.addEventListener('change', (event) => {
    if (!(event.target instanceof HTMLInputElement)) return;
    if (!event.target.matches('[data-cart-drawer-qty-input]')) return;
    const line = event.target.closest('[data-cart-line-key]');
    if (!line) return;
    const nextQuantity = Math.max(0, Number(event.target.value || 0));
    event.target.value = nextQuantity;
    updateCartLine(line.dataset.cartLineKey, nextQuantity, line)
      .catch(() => renderCartStatus('Could not update cart. Please try again.', true));
  });
  window.addEventListener('keydown', (event) => {
    trapOverlayFocus(event);
    const modSearch = (event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k';
    if (modSearch) {
      event.preventDefault();
      setSearch(true);
    } else if (event.key === 'Escape') {
      const activeImageViewer = document.querySelector('[data-pdp-image-viewer].open');
      if (activeImageViewer) {
        event.preventDefault();
        activeImageViewer.dispatchEvent(new CustomEvent('pdp-image-viewer:close'));
        return;
      }
      closeMegaMenus();
      setSearch(false);
      setMobileNav(false);
      setFilters(false);
      setCart(false);
      setNewsletterPopup(false);
    }
  });
  document.addEventListener('touchstart', rememberOverlayTouch, { passive: true });
  document.addEventListener('touchmove', guardOverlayTouch, { passive: false });
  document.addEventListener('wheel', guardOverlayWheel, { passive: false });

  const scheduleIdle = (callback, timeout = 1600) => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout });
    } else {
      window.setTimeout(callback, 80);
    }
  };
  let deferredImageObserver = null;
  const markImageLoaded = (image) => {
    image.classList.remove('is-loading');
    image.classList.add('is-loaded');
    image.closest('.home-feature-media')?.classList.add('is-loaded');
  };
  const prepareDeferredImage = (image) => {
    image.classList.add('is-loading');
  };
  const loadDeferredImage = (image) => {
    if (!(image instanceof HTMLImageElement)) return;
    if (!image.hasAttribute('data-defer-image') && !image.hasAttribute('data-pdp-lazy-image')) return;
    if (image.dataset.loadingStarted === 'true') return;
    image.dataset.loadingStarted = 'true';
    deferredImageObserver?.unobserve(image);
    prepareDeferredImage(image);

    let didFinish = false;
    const finish = () => {
      if (didFinish) return;
      didFinish = true;
      image.removeEventListener('load', finish);
      image.removeEventListener('error', finish);
      markImageLoaded(image);
    };
    image.addEventListener('load', finish);
    image.addEventListener('error', finish);

    const picture = image.closest('picture');
    if (picture) {
      picture.querySelectorAll('source[data-srcset]').forEach((source) => {
        source.srcset = source.dataset.srcset;
        source.removeAttribute('data-srcset');
      });
    }
    if (image.loading === 'lazy') image.loading = 'eager';
    if (image.dataset.srcset) image.srcset = image.dataset.srcset;
    if (image.dataset.src) image.src = image.dataset.src;
    image.removeAttribute('data-defer-image');
    image.removeAttribute('data-pdp-lazy-image');
    image.removeAttribute('data-srcset');
    image.removeAttribute('data-src');
    window.requestAnimationFrame(() => {
      if (image.complete) finish();
    });
  };
  const loadDeferredImagesIn = (root = document) => {
    root.querySelectorAll('img[data-defer-image], img[data-pdp-lazy-image]').forEach(loadDeferredImage);
  };
  const isImageWithinLoadRange = (image) => {
    const rect = image.getBoundingClientRect();
    const verticalMargin = Math.max(window.innerHeight * 1.2, 720);
    const horizontalMargin = window.innerWidth;
    return rect.width > 0
      && rect.height > 0
      && rect.bottom > -verticalMargin
      && rect.right > -horizontalMargin
      && rect.top < window.innerHeight + verticalMargin
      && rect.left < window.innerWidth + horizontalMargin;
  };
  const startDeferredImageLoading = (root = document) => {
    const images = Array.from(root.querySelectorAll('img[data-defer-image], img[data-pdp-lazy-image]'))
      .filter((image) => image.dataset.deferQueued !== 'true')
      .filter((image) => !image.closest('[data-hero-slide][aria-hidden="true"]'));
    if (!images.length) return;

    images.forEach((image) => {
      image.dataset.deferQueued = 'true';
      prepareDeferredImage(image);
    });

    if ('IntersectionObserver' in window && !deferredImageObserver) {
      try {
        deferredImageObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            loadDeferredImage(entry.target);
          });
        }, {
          rootMargin: '900px 1000px 1200px 1000px',
          threshold: 0.01
        });
      } catch (error) {
        deferredImageObserver = null;
      }
    }

    images.forEach((image) => {
      if (isImageWithinLoadRange(image)) {
        loadDeferredImage(image);
      } else if (deferredImageObserver) {
        deferredImageObserver.observe(image);
      } else {
        scheduleIdle(() => loadDeferredImage(image));
      }
    });
  };
  startDeferredImageLoading();

  document.querySelectorAll('[data-hero-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-hero-track]');
    const slides = Array.from(carousel.querySelectorAll('[data-hero-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-hero-dot]'));
    const toggle = carousel.querySelector('[data-hero-toggle]');
    const toggleIcon = carousel.querySelector('[data-hero-toggle-icon]');
    const togglePauseIcon = carousel.querySelector('[data-hero-toggle-pause]');
    const togglePlayIcon = carousel.querySelector('[data-hero-toggle-play]');
    if (!track || slides.length < 2) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const delay = Math.max(3000, Number(carousel.dataset.autoplay || 4000));
    let activeIndex = 0;
    let autoplayTimer = 0;
    let scrollTimer = 0;
    let firstAutoplayScheduled = false;
    let firstAutoplayWaiting = false;
    let userPaused = reduceMotion;
    let interactionPaused = false;
    let inView = true;
    let initialSlideReady = false;

    const loadSlideImages = (index) => {
      const slide = slides[(index + slides.length) % slides.length];
      if (!slide) return;
      slide.querySelectorAll('img[data-defer-image]').forEach(loadDeferredImage);
    };
    const preloadNextSlideImages = (index) => {
      scheduleIdle(() => loadSlideImages(index + 1));
    };
    const preloadInitialNextSlideImages = () => {
      const firstSlideImage = slides[0]?.querySelector('img');
      let didSchedule = false;
      const schedule = () => {
        if (didSchedule) return;
        didSchedule = true;
        initialSlideReady = true;
        preloadNextSlideImages(0);
        scheduleAutoplay();
      };

      if (!firstSlideImage || firstSlideImage.complete) {
        schedule();
        return;
      }

      firstSlideImage.addEventListener('load', schedule, { once: true });
      firstSlideImage.addEventListener('error', schedule, { once: true });
    };

    const stopAutoplay = () => {
      window.clearTimeout(autoplayTimer);
      autoplayTimer = 0;
    };

    const canAutoplay = () => (
      initialSlideReady
      && !userPaused
      && !interactionPaused
      && inView
      && !document.hidden
    );

    const updateToggle = () => {
      if (!toggle) return;
      toggle.setAttribute('aria-label', userPaused ? 'Play hero slideshow' : 'Pause hero slideshow');
      if (togglePauseIcon && togglePlayIcon) {
        togglePauseIcon.hidden = userPaused;
        togglePlayIcon.hidden = !userPaused;
      } else if (toggleIcon) {
        toggleIcon.textContent = userPaused ? '>' : 'II';
      }
    };

    const setActive = (index, scrollToSlide = true, preloadNext = true) => {
      const nextIndex = (index + slides.length) % slides.length;
      activeIndex = nextIndex;
      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === nextIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        if (isActive) {
          slide.removeAttribute('tabindex');
        } else {
          slide.setAttribute('tabindex', '-1');
        }
      });
      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === nextIndex;
        dot.classList.toggle('is-active', isActive);
        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
      loadSlideImages(nextIndex);
      if (preloadNext) preloadNextSlideImages(nextIndex);
      if (scrollToSlide) {
        track.scrollTo({ left: slides[nextIndex].offsetLeft, behavior: 'auto' });
      }
    };

    const scheduleAutoplay = () => {
      if (firstAutoplayWaiting && autoplayTimer) return;
      stopAutoplay();
      if (!canAutoplay()) return;
      const nextDelay = firstAutoplayScheduled ? delay : Math.max(delay, 8000);
      firstAutoplayScheduled = true;
      firstAutoplayWaiting = nextDelay > delay;
      autoplayTimer = window.setTimeout(() => {
        firstAutoplayWaiting = false;
        setActive(activeIndex + 1);
        scheduleAutoplay();
      }, nextDelay);
    };

    const closestSlideIndex = () => {
      const left = track.scrollLeft;
      return slides.reduce((closest, slide, index) => {
        const currentDelta = Math.abs(slide.offsetLeft - left);
        const closestDelta = Math.abs(slides[closest].offsetLeft - left);
        return currentDelta < closestDelta ? index : closest;
      }, 0);
    };

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        setActive(index);
        scheduleAutoplay();
      });
    });

    toggle?.addEventListener('click', () => {
      userPaused = !userPaused;
      updateToggle();
      scheduleAutoplay();
    });

    track.addEventListener('scroll', () => {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(() => {
        setActive(closestSlideIndex(), false);
        scheduleAutoplay();
      }, 90);
    }, { passive: true });

    carousel.addEventListener('pointerdown', () => {
      interactionPaused = true;
      stopAutoplay();
    });
    ['pointerup', 'pointercancel'].forEach((eventName) => {
      carousel.addEventListener(eventName, () => {
        interactionPaused = false;
        scheduleAutoplay();
      });
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopAutoplay();
      else scheduleAutoplay();
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        inView = entries.some((entry) => entry.isIntersecting);
        if (inView) scheduleAutoplay();
        else stopAutoplay();
      }, { threshold: 0.35 });
      observer.observe(carousel);
    }

    track.scrollLeft = 0;
    setActive(0, false, false);
    preloadInitialNextSlideImages();
    updateToggle();
    scheduleAutoplay();
  });

  const collectionFilterForm = document.querySelector('[data-collection-filter-form]');
  const mobileFilterQuery = window.matchMedia('(max-width: 880px)');
  if (collectionFilterForm) {
    const defaultAvailabilityName = collectionFilterForm.dataset.defaultAvailabilityName || '';
    const defaultAvailabilityValue = collectionFilterForm.dataset.defaultAvailabilityValue || '';
    const defaultAvailabilityOptOutHash = collectionFilterForm.dataset.defaultAvailabilityOptOutHash || 'availability-all';
    const defaultAvailabilityInput = () => Array.from(collectionFilterForm.querySelectorAll('input[type="checkbox"]'))
      .find((input) => input.name === defaultAvailabilityName && input.value === defaultAvailabilityValue);
    const currentParams = new URLSearchParams(window.location.search);
    const hasDefaultAvailabilityParam = defaultAvailabilityName && currentParams.has(defaultAvailabilityName);
    const isDefaultAvailabilityOptOut = defaultAvailabilityName && window.location.hash === `#${defaultAvailabilityOptOutHash}`;

    if (isDefaultAvailabilityOptOut && !hasDefaultAvailabilityParam) {
      const input = defaultAvailabilityInput();
      if (input) {
        input.checked = false;
        input.closest('.filter-choice')?.classList.remove('on');
      }
      document.querySelectorAll('[data-default-availability-sort-input]').forEach((input) => input.remove());
    }

    const buildCollectionFilterUrl = () => {
      const baseUrl = collectionFilterForm.dataset.collectionBaseUrl || collectionFilterForm.getAttribute('action') || window.location.pathname;
      const formData = new FormData(collectionFilterForm);
      const params = new URLSearchParams();

      formData.forEach((value, key) => {
        if (value === '') return;
        params.append(key, value);
      });

      const currentParams = new URLSearchParams(window.location.search);
      if (currentParams.has('preview_theme_id') && !params.has('preview_theme_id')) {
        params.set('preview_theme_id', currentParams.get('preview_theme_id'));
      }

      const query = params.toString();
      const hasAvailabilitySelection = defaultAvailabilityName && params.has(defaultAvailabilityName);
      const defaultInput = defaultAvailabilityInput();
      const hash = defaultAvailabilityName && defaultInput && !defaultInput.checked && !hasAvailabilitySelection
        ? `#${defaultAvailabilityOptOutHash}`
        : '';
      return `${query ? `${baseUrl}?${query}` : baseUrl}${hash}`;
    };

    const submitCollectionFilters = () => {
      const nextUrl = buildCollectionFilterUrl();
      window.location.href = nextUrl;
    };

    collectionFilterForm.addEventListener('submit', (event) => {
      event.preventDefault();
      submitCollectionFilters();
    });

    collectionFilterForm.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.type !== 'checkbox') return;
      input.closest('.filter-choice')?.classList.toggle('on', input.checked);
      if (!mobileFilterQuery.matches) {
        if (typeof collectionFilterForm.requestSubmit === 'function') {
          collectionFilterForm.requestSubmit();
        } else {
          submitCollectionFilters();
        }
      }
    });
  }

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const form = root.querySelector('[data-product-form]');
    const variantSelect = root.querySelector('[data-variant-select]');
    const variants = JSON.parse(root.dataset.variants || '[]');
    const price = root.querySelector('[data-product-price]');
    const afterpayInstallment = root.querySelector('[data-afterpay-installment]');
    const addButton = root.querySelector('[data-add-button]');
    const addLabel = root.querySelector('[data-add-label]');
    const qtyControl = root.querySelector('[data-qty-control]');
    const qtyInput = root.querySelector('[data-qty-input]');
    const stockStatus = root.querySelector('[data-variant-stock]');
    const stockStatusLabel = root.querySelector('[data-variant-stock-label]');
    const availabilityMessage = root.querySelector('[data-variant-availability-message]');
    const orderTypeInput = root.querySelector('[data-order-type-input]');
    const variantRows = Array.from(root.querySelectorAll('[data-variant-row]'));
    const availabilityGroups = Array.from(root.querySelectorAll('[data-availability-group]'));
    const availabilityToggles = Array.from(root.querySelectorAll('[data-availability-toggle]'));
    const selectedVariantLabel = root.querySelector('[data-selected-variant-label]');
    const isDemoProduct = Boolean(root.querySelector('[data-demo-booking-fields]'));
    const demoVariantLabels = Array.from(root.querySelectorAll('[data-demo-variant-label]'));
    const demoDateInputs = Array.from(root.querySelectorAll('[data-demo-date-input]'));
    const selectedVariant = variants.find((variant) => String(variant.id) === variantSelect?.value) || variants[0];
    const selectedOptions = {};
    selectedVariant?.options?.forEach((value, index) => {
      selectedOptions[index + 1] = value;
    });
    const stockLabel = (state) => ({
      in: 'In stock',
      order: 'Order in',
      out: 'Out of stock'
    })[state] || 'Out of stock';
    const orderTypeLabel = (state) => ({
      in: 'In Stock',
      order: 'Order In',
      out: 'Out of Stock'
    })[state] || 'Out of Stock';
    const stockState = (variant) => {
      if (!variant) return 'out';
      const policy = variant.inventoryPolicy || variant.inventory_policy;
      const management = variant.inventoryManagement || variant.inventory_management;
      const quantity = Number(variant.inventoryQuantity ?? variant.inventory_quantity ?? 0);
      if (variant.available && management && policy === 'continue' && quantity <= 0) return 'order';
      return variant.available ? 'in' : 'out';
    };
    const shouldShowQuantityControl = (variant) => {
      if (!variant || !variant.available) return false;
      const policy = variant.inventoryPolicy || variant.inventory_policy;
      const management = variant.inventoryManagement || variant.inventory_management;
      const quantity = Number(variant.inventoryQuantity ?? variant.inventory_quantity ?? 0);
      return !management || policy === 'continue' || quantity > 1;
    };
    const rowForVariant = (variant) => variantRows.find((row) => String(row.dataset.variantId) === String(variant?.id));
    const mediaIdForVariant = (variant) => String(variant?.featuredMediaId || variant?.featured_media?.id || '');
    const imageIdForVariant = (variant) => String(variant?.featuredImageId || variant?.featured_image?.id || '');
    const variantsForMedia = (mediaId) => {
      const mediaIdString = String(mediaId || '');
      if (!mediaIdString) return [];
      return variants.filter((variant) => mediaIdForVariant(variant) === mediaIdString);
    };
    const bestMatchingVariant = (candidates) => {
      if (!candidates.length) return null;
      const currentId = variantSelect?.value;
      const currentMatch = candidates.find((variant) => String(variant.id) === String(currentId));
      if (currentMatch) return currentMatch;
      return candidates
        .map((variant, index) => {
          const optionScore = variant.options?.reduce((score, value, optionIndex) => (
            selectedOptions[optionIndex + 1] === value ? score + 1 : score
          ), 0) || 0;
          const stateScore = stockState(variant) === 'out' ? 0 : 1;
          return { variant, score: (optionScore * 10) + stateScore, index };
        })
        .sort((a, b) => b.score - a.score || a.index - b.index)[0]?.variant || candidates[0];
    };
    const variantForImage = (imageId) => {
      const imageIdString = String(imageId || '');
      if (!imageIdString) return null;
      return bestMatchingVariant(variants.filter((variant) => imageIdForVariant(variant) === imageIdString));
    };
    const variantForMedia = (mediaId, imageId = '') => (
      bestMatchingVariant(variantsForMedia(mediaId)) || variantForImage(imageId)
    );
    const setSelectedStock = (state, label = stockLabel(state)) => {
      if (stockStatus) {
        stockStatus.classList.remove('pdp-stock-status--in', 'pdp-stock-status--order', 'pdp-stock-status--out');
        stockStatus.classList.add(`pdp-stock-status--${state}`);
      }
      if (stockStatusLabel) stockStatusLabel.textContent = label;
    };
    const setAvailabilityMessage = (variant, state) => {
      if (!availabilityMessage) return;
      const message = variant?.availabilityMessages?.[state] || '';
      availabilityMessage.textContent = message;
      availabilityMessage.hidden = !message;
    };
    const openAvailabilityGroup = (state) => {
      if (!availabilityGroups.length) return;
      const target = availabilityGroups.find((group) => group.dataset.availabilityState === state);
      if (!target) return;
      availabilityGroups.forEach((group) => {
        const hasToggle = Boolean(group.querySelector('[data-availability-toggle]'));
        group.open = group === target || group.dataset.availabilityState === 'in' || group.dataset.availabilityState === 'order' || group.dataset.availabilityState === 'out' || hasToggle;
      });
    };
    const setAvailabilityLimit = (group, expanded) => {
      if (!group) return;
      const toggle = group.querySelector('[data-availability-toggle]');
      group.classList.toggle('is-expanded', expanded);
      if (!toggle) return;
      const label = toggle.querySelector('[data-availability-toggle-label]');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      toggle.setAttribute('aria-label', expanded ? 'Show fewer options' : 'Show more options');
      if (label) label.textContent = expanded ? toggle.dataset.lessLabel : toggle.dataset.moreLabel;
    };

    const setVariant = (next, row = rowForVariant(next), syncHistory = true) => {
      const state = row?.dataset.stockState || stockState(next);
      const label = row?.dataset.stockLabel || stockLabel(state);
      openAvailabilityGroup(state);
      if (row?.hasAttribute('data-availability-extra')) {
        setAvailabilityLimit(row.closest('[data-availability-group]'), true);
      }
      const colourSizeGroup = row?.closest('[data-colour-size-colour]');
      if (colourSizeGroup && 'open' in colourSizeGroup) {
        colourSizeGroup.open = true;
      }
      setSelectedStock(state, label);
      setAvailabilityMessage(next, state);
      if (orderTypeInput) orderTypeInput.value = orderTypeLabel(state);
      if (!next) {
        if (qtyControl) qtyControl.hidden = true;
        if (addButton && addLabel) {
          addButton.disabled = true;
          addButton.classList.add('btn--disabled');
          addButton.classList.remove('btn--order');
          addLabel.textContent = 'Unavailable';
        }
        return;
      }
      if (variantSelect) variantSelect.value = next.id;
      next.options?.forEach((value, index) => {
        selectedOptions[index + 1] = value;
      });
      if (price) price.textContent = money(next.price);
      if (afterpayInstallment) afterpayInstallment.textContent = money(Math.round(next.price / 4));
      if (qtyControl) qtyControl.hidden = !shouldShowQuantityControl(next);
      if (qtyInput) qtyInput.value = '1';
      const variantTitle = row?.dataset.variantTitle || next.options?.join(' / ') || '';
      if (selectedVariantLabel) {
        selectedVariantLabel.textContent = variantTitle;
      }
      demoVariantLabels.forEach((labelEl) => {
        labelEl.textContent = variantTitle;
      });
      if (addButton && addLabel) {
        addButton.disabled = state === 'out';
        addButton.classList.toggle('btn--disabled', state === 'out');
        addButton.classList.toggle('btn--order', state === 'order');
        addLabel.textContent = isDemoProduct && state !== 'out'
          ? 'Add demo to cart'
          : state === 'in'
          ? `Add to cart - ${money(next.price)}`
          : state === 'order'
            ? `Order in - ${money(next.price)}`
            : 'Out of stock';
      }
      variantRows.forEach((variantRow) => {
        const selected = row ? variantRow === row : String(variantRow.dataset.variantId) === String(next.id);
        variantRow.classList.toggle('on', selected);
        variantRow.setAttribute('aria-pressed', selected ? 'true' : 'false');
        const selectedLabel = variantRow.querySelector('[data-selected-label]');
        if (selectedLabel) selectedLabel.hidden = !selected;
      });
      const variantMediaId = mediaIdForVariant(next);
      const variantImageId = row?.dataset.variantImageId || imageIdForVariant(next);
      const grid = root.closest('.pdp-grid');
      if ((variantMediaId || variantImageId) && grid) {
        grid.dispatchEvent(new CustomEvent('pdp:variant-image-selected', {
          bubbles: true,
          detail: {
            mediaId: variantMediaId,
            imageId: String(variantImageId || '')
          }
        }));
      }
      if (syncHistory && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', next.id);
        window.history.replaceState({}, '', url.toString());
      }
    };

    availabilityToggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const group = toggle.closest('[data-availability-group]');
        setAvailabilityLimit(group, !group?.classList.contains('is-expanded'));
      });
    });
    variantRows.forEach((row) => {
      const selectRow = () => {
        const next = variants.find((variant) => String(variant.id) === row.dataset.variantId);
        setVariant(next, row);
      };
      row.addEventListener('click', selectRow);
      row.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        selectRow();
      });
    });
    variantSelect?.addEventListener('change', () => {
      const next = variants.find((variant) => String(variant.id) === variantSelect.value);
      setVariant(next);
    });
    root.closest('.pdp-grid')?.addEventListener('pdp:image-selected', (event) => {
      const imageId = event.detail?.imageId;
      const next = variantForImage(imageId);
      if (!next) return;
      if (String(next.id) === String(variantSelect?.value)) return;
      setVariant(next, rowForVariant(next));
    });
    root.closest('.pdp-grid')?.addEventListener('pdp:media-selected', (event) => {
      const next = variantForMedia(event.detail?.mediaId, event.detail?.imageId);
      if (!next) return;
      if (String(next.id) === String(variantSelect?.value)) return;
      setVariant(next, rowForVariant(next));
    });
    setVariant(selectedVariant, rowForVariant(selectedVariant), false);

    form?.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      if (!qtyInput) return;
      qtyInput.value = Math.max(1, Number(qtyInput.value || 1) - 1);
    });
    form?.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      if (!qtyInput) return;
      qtyInput.value = Number(qtyInput.value || 1) + 1;
    });
    demoDateInputs.forEach((input) => {
      const control = input.closest('[data-demo-date-control]');
      const syncDateState = () => control?.classList.toggle('has-value', Boolean(input.value));
      const syncFocusState = () => control?.classList.toggle('is-focused', document.activeElement === input);
      const openDatePicker = () => {
        input.focus({ preventScroll: true });
        syncFocusState();
        if (typeof input.showPicker !== 'function') return;
        try {
          input.showPicker();
        } catch (error) {
          // Some browsers only allow showPicker during a direct user gesture.
        }
      };
      syncDateState();
      input.addEventListener('input', syncDateState);
      input.addEventListener('change', syncDateState);
      input.addEventListener('focus', syncFocusState);
      input.addEventListener('blur', syncFocusState);
      control?.addEventListener('click', openDatePicker);
      input.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        openDatePicker();
      });
    });

    const addCartForm = async (cartForm, button) => {
      if (!cartForm || !button || button.disabled) return;
      const formData = new FormData(cartForm);
      const quantity = Math.max(1, Number(formData.get('quantity') || 1));
      const previousCount = Number(cartCountEls[0]?.textContent || 0);
      button.disabled = true;
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');
      setCart(true);
      renderCartStatus('Adding to cart');
      try {
        const response = await fetch(`${routesRoot}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        });
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || 'Could not add to cart');
        }
        setCartCount(previousCount + quantity);
        fetchCart().catch(() => renderCartStatus('Item added, but the cart could not refresh.', true));
      } catch (error) {
        renderCartStatus(error.message || 'Could not add to cart. Please try again.', true);
      } finally {
        button.disabled = button.classList.contains('btn--disabled');
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
      }
    };

    form?.addEventListener('submit', async (event) => {
      if (event.submitter && event.submitter !== addButton) return;
      event.preventDefault();
      await addCartForm(form, addButton);
    });
  });

  const setupRichTextToggle = ({ rootSelector, contentSelector, toggleSelector, previewLines, overflowToleranceLines = 1, mediaQuery = '', cleanContent = true, allowTrustedVideoEmbeds = false }) => {
    const previewMedia = mediaQuery ? window.matchMedia(mediaQuery) : null;
    document.querySelectorAll(rootSelector).forEach((description) => {
      const content = description.querySelector(contentSelector);
      const toggle = description.querySelector(toggleSelector);
      if (!content || !toggle) return;

      if (cleanContent) cleanPastedRichText(content, { allowTrustedVideoEmbeds });

      const resetDescriptionToggle = () => {
        description.classList.remove('is-collapsible');
        description.classList.remove('is-expanded');
        toggle.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        toggle.textContent = 'More';
      };

      const updateDescriptionToggle = () => {
        const isActiveViewport = !previewMedia || previewMedia.matches;
        const customPreviewLines = Number.parseInt(description.dataset.richTextPreviewLines || '', 10);
        const activePreviewLines = Number.isFinite(customPreviewLines) && customPreviewLines > 0 ? customPreviewLines : previewLines;
        const styles = window.getComputedStyle(content);
        const lineHeight = Number.parseFloat(styles.lineHeight) || 24;
        const previewHeight = lineHeight * activePreviewLines;
        description.style.setProperty('--plp-description-preview-height', `${previewHeight}px`);

        if (!isActiveViewport || content.scrollHeight <= previewHeight + (lineHeight * overflowToleranceLines)) {
          resetDescriptionToggle();
          return;
        }

        description.classList.add('is-collapsible');
        toggle.hidden = false;
      };

      toggle.addEventListener('click', () => {
        if (toggle.hidden) return;
        const expanded = !description.classList.contains('is-expanded');
        description.classList.toggle('is-expanded', expanded);
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        toggle.textContent = expanded ? 'Less' : 'More';
      });

      let resizeTimer;
      window.addEventListener('resize', () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(updateDescriptionToggle, 120);
      });
      if (previewMedia) {
        if (typeof previewMedia.addEventListener === 'function') {
          previewMedia.addEventListener('change', updateDescriptionToggle);
        } else if (typeof previewMedia.addListener === 'function') {
          previewMedia.addListener(updateDescriptionToggle);
        }
      }

      updateDescriptionToggle();
    });
  };

  setupRichTextToggle({
    rootSelector: '[data-product-description]',
    contentSelector: '[data-product-description-content]',
    toggleSelector: '[data-product-description-toggle]',
    previewLines: 7,
    allowTrustedVideoEmbeds: true
  });

  setupRichTextToggle({
    rootSelector: '[data-collection-description]',
    contentSelector: '[data-collection-description-content]',
    toggleSelector: '[data-collection-description-toggle]',
    previewLines: 3,
    overflowToleranceLines: 0
  });

  setupRichTextToggle({
    rootSelector: '[data-plp-helper]',
    contentSelector: '[data-plp-helper-content]',
    toggleSelector: '[data-plp-helper-toggle]',
    previewLines: 3,
    overflowToleranceLines: 1,
    cleanContent: false
  });

  document.querySelectorAll('[data-pdp-swiper]').forEach((gallery) => {
    const viewport = gallery.querySelector('[data-pdp-swiper-viewport]');
    const slides = Array.from(gallery.querySelectorAll('[data-pdp-slide]'));
    const imageSlides = slides.filter((slide) => slide.dataset.mediaType === 'image');
    const thumbs = Array.from(gallery.querySelectorAll('[data-product-thumb]'));
    const prev = gallery.querySelector('[data-pdp-prev]');
    const next = gallery.querySelector('[data-pdp-next]');
    const current = gallery.querySelector('[data-pdp-current]');
    const imageViewerTrigger = gallery.querySelector('[data-pdp-image-viewer-trigger]');
    const imageViewer = gallery.querySelector('[data-pdp-image-viewer]');
    const imageViewerViewport = imageViewer?.querySelector('[data-pdp-image-viewer-viewport]');
    const imageViewerImage = imageViewer?.querySelector('[data-pdp-image-viewer-image]');
    const imageViewerLoader = imageViewer?.querySelector('[data-pdp-image-viewer-loader]');
    const imageViewerCurrent = imageViewer?.querySelector('[data-pdp-image-viewer-current]');
    const imageViewerClose = imageViewer?.querySelector('.pdp-image-viewer__close');
    const imageViewerPrev = imageViewer?.querySelector('[data-pdp-image-viewer-prev]');
    const imageViewerNext = imageViewer?.querySelector('[data-pdp-image-viewer-next]');
    const grid = gallery.closest('.pdp-grid');
    if (!viewport || !slides.length) return;

    let activeIndex = 0;
    let imageViewerIndex = 0;
    let imageViewerImageKey = '';
    let scrollFrame = null;
    let ignoreNextSlideClick = false;
    const wrapIndex = (value) => ((value % slides.length) + slides.length) % slides.length;
    const wrapImageIndex = (value) => imageSlides.length
      ? ((value % imageSlides.length) + imageSlides.length) % imageSlides.length
      : 0;
    const suppressNextSlideClick = () => {
      ignoreNextSlideClick = true;
      window.setTimeout(() => {
        ignoreNextSlideClick = false;
      }, 0);
    };
    const alignActiveThumb = () => {
      thumbs[activeIndex]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    };
    const loadSlideImage = (index) => {
      slides[wrapIndex(index)]?.querySelectorAll('img[data-defer-image], img[data-pdp-lazy-image]').forEach(loadDeferredImage);
    };
    const loadSlideNeighborhood = (index) => {
      loadSlideImage(index);
      if (slides.length > 1) loadSlideImage(index + 1);
      if (slides.length > 2) loadSlideImage(index - 1);
    };
    const pauseMediaInSlide = (slide) => {
      if (!slide) return;
      slide.querySelectorAll('video').forEach((video) => video.pause());
      slide.querySelectorAll('iframe').forEach((iframe) => {
        const source = iframe.getAttribute('src') || '';
        try {
          const url = new URL(source, window.location.origin);
          if (/(^|\.)youtube(?:-nocookie)?\.com$/i.test(url.hostname)) {
            iframe.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), url.origin);
          } else if (url.hostname === 'player.vimeo.com') {
            iframe.contentWindow?.postMessage({ method: 'pause' }, url.origin);
          }
        } catch (error) {
          // Ignore malformed third-party player URLs.
        }
      });
    };
    const syncVariantToMedia = (index) => {
      const slide = slides[wrapIndex(index)];
      if (!slide || slide.dataset.mediaType !== 'image') return;
      const mediaId = slide.dataset.mediaId;
      if (!mediaId) return;
      grid?.dispatchEvent(new CustomEvent('pdp:media-selected', {
        bubbles: true,
        detail: { mediaId }
      }));
    };
    const nearestIndex = () => {
      const viewportCenter = viewport.scrollLeft + (viewport.clientWidth / 2);
      return slides.reduce((nearest, slide, index) => {
        const distance = Math.abs((slide.offsetLeft + (slide.offsetWidth / 2)) - viewportCenter);
        return distance < nearest.distance ? { index, distance } : nearest;
      }, { index: activeIndex, distance: Infinity }).index;
    };

    const setActive = (index, shouldScroll = true, shouldSyncVariant = false) => {
      activeIndex = wrapIndex(index);
      loadSlideNeighborhood(activeIndex);
      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === activeIndex;
        slide.inert = !isActive;
        if (isActive) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('aria-hidden', 'true');
          pauseMediaInSlide(slide);
        }
      });
      thumbs.forEach((thumb, thumbIndex) => {
        const isActive = thumbIndex === activeIndex;
        thumb.classList.toggle('on', isActive);
        if (isActive) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
      alignActiveThumb();
      if (current) current.textContent = String(activeIndex + 1);
      if (prev) prev.disabled = false;
      if (next) next.disabled = false;
      if (imageViewerTrigger) imageViewerTrigger.hidden = slides[activeIndex].dataset.mediaType !== 'image';
      if (shouldScroll) viewport.scrollTo({ left: slides[activeIndex].offsetLeft, behavior: 'auto' });
      if (shouldSyncVariant) syncVariantToMedia(activeIndex);
    };

    const imageViewerDataFor = (index) => {
      const slide = imageSlides[wrapImageIndex(index)];
      const image = slide?.querySelector('img');
      return {
        src: slide?.dataset.fullSrc || image?.currentSrc || image?.dataset.src || image?.src || '',
        srcset: slide?.dataset.fullSrcset || image?.dataset.srcset || image?.srcset || '',
        alt: slide?.dataset.fullAlt || image?.alt || '',
        width: slide?.dataset.fullWidth || image?.width || '',
        height: slide?.dataset.fullHeight || image?.height || ''
      };
    };
    const setImageViewerLoading = (loading) => {
      if (!imageViewer) return;
      imageViewer.classList.toggle('is-loading', loading);
      if (imageViewerLoader) imageViewerLoader.hidden = !loading;
    };
    const setImageViewerImage = (index, shouldSyncGallery = false) => {
      if (!imageViewerImage || !imageSlides.length) return;
      imageViewerIndex = wrapImageIndex(index);
      if (shouldSyncGallery) {
        const galleryIndex = slides.indexOf(imageSlides[imageViewerIndex]);
        if (galleryIndex > -1) setActive(galleryIndex, true, true);
      }

      const data = imageViewerDataFor(imageViewerIndex);
      if (!data.src) return;
      const useNativeMobileZoom = window.matchMedia('(max-width: 640px)').matches;
      const nextImageKey = `${data.src}|${data.srcset}`;
      const imageChanged = nextImageKey !== imageViewerImageKey;
      imageViewerImageKey = nextImageKey;
      if (imageChanged || !imageViewerImage.complete || !imageViewerImage.naturalWidth) {
        setImageViewerLoading(true);
      }
      imageViewerImage.alt = data.alt;
      if (data.width) imageViewerImage.width = data.width;
      if (data.height) imageViewerImage.height = data.height;
      if (useNativeMobileZoom) {
        imageViewerImage.removeAttribute('sizes');
        imageViewerImage.removeAttribute('srcset');
      } else if (data.srcset) {
        imageViewerImage.sizes = '100vw';
        imageViewerImage.srcset = data.srcset;
      } else {
        imageViewerImage.removeAttribute('sizes');
        imageViewerImage.removeAttribute('srcset');
      }
      if (imageViewerImage.src !== data.src) imageViewerImage.src = data.src;
      window.requestAnimationFrame(() => {
        if (imageViewerImageKey === nextImageKey && imageViewerImage.complete && imageViewerImage.naturalWidth) {
          setImageViewerLoading(false);
        }
      });
      if (imageViewerCurrent) imageViewerCurrent.textContent = String(imageViewerIndex + 1);
    };
    const setImageViewerOpen = (open, index = activeIndex) => {
      if (!imageViewer || !imageViewerViewport || !imageViewerImage || !imageSlides.length) return;
      const nextImageIndex = open ? imageSlides.indexOf(slides[wrapIndex(index)]) : -1;
      if (open && nextImageIndex < 0) return;
      const wasOpen = imageViewer.classList.contains('open');
      if (open && !wasOpen) saveFocus('imageViewer');

      imageViewer.hidden = !open;
      imageViewer.classList.toggle('open', open);
      imageViewer.setAttribute('aria-hidden', open ? 'false' : 'true');
      syncBodyLock();

      if (open) {
        setImageViewerImage(nextImageIndex);
        focusOverlay(imageViewer, imageViewerClose || imageViewerViewport);
      } else if (wasOpen) {
        setImageViewerLoading(false);
        restoreFocus('imageViewer');
      }
    };

    const indexForThumb = (thumb, fallbackIndex = 0) => {
      const thumbMediaId = String(thumb?.dataset?.mediaId || '');
      const mediaIndex = thumbMediaId
        ? slides.findIndex((slide) => slide.dataset.mediaId === thumbMediaId)
        : -1;
      return mediaIndex > -1 ? mediaIndex : Number(thumb?.dataset?.slideIndex || fallbackIndex);
    };
    const selectThumb = (thumb, fallbackIndex = 0) => {
      if (!thumb) return;
      setActive(indexForThumb(thumb, fallbackIndex), true, true);
    };
    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', (event) => {
        event.preventDefault();
        selectThumb(thumb, index);
      });
    });
    grid?.addEventListener('pdp:variant-image-selected', (event) => {
      const mediaId = String(event.detail?.mediaId || '');
      const imageId = String(event.detail?.imageId || '');
      let nextIndex = mediaId
        ? slides.findIndex((slide) => slide.dataset.mediaId === mediaId)
        : -1;
      if (nextIndex < 0 && imageId) {
        nextIndex = slides.findIndex((slide) => slide.dataset.imageId === imageId);
      }
      if (nextIndex > -1) setActive(nextIndex, true);
    });
    viewport.addEventListener('click', (event) => {
      if (ignoreNextSlideClick) return;
      const target = event.target instanceof Element ? event.target : null;
      const slide = target?.closest('[data-pdp-slide]');
      if (!slide || slide.dataset.mediaType !== 'image') return;
      const index = slides.indexOf(slide);
      setImageViewerOpen(true, index > -1 ? index : activeIndex);
    });
    slides.forEach((slide, index) => {
      slide.addEventListener('keydown', (event) => {
        if (slide.dataset.mediaType !== 'image') return;
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        setImageViewerOpen(true, index);
      });
    });
    imageViewer?.addEventListener('pdp-image-viewer:close', () => setImageViewerOpen(false));
    imageViewerClose?.addEventListener('click', () => setImageViewerOpen(false));
    imageViewer?.querySelectorAll('[data-pdp-image-viewer-close]').forEach((button) => {
      if (button === imageViewerClose) return;
      button.addEventListener('click', () => setImageViewerOpen(false));
    });
    imageViewerTrigger?.addEventListener('click', () => setImageViewerOpen(true, activeIndex));
    imageViewerPrev?.addEventListener('click', () => setImageViewerImage(imageViewerIndex - 1, true));
    imageViewerNext?.addEventListener('click', () => setImageViewerImage(imageViewerIndex + 1, true));
    imageViewerImage?.addEventListener('load', () => setImageViewerLoading(false));
    imageViewerImage?.addEventListener('error', () => setImageViewerLoading(false));
    imageViewer?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft' && imageSlides.length > 1) {
        event.preventDefault();
        setImageViewerImage(imageViewerIndex - 1, true);
      } else if (event.key === 'ArrowRight' && imageSlides.length > 1) {
        event.preventDefault();
        setImageViewerImage(imageViewerIndex + 1, true);
      }
    });
    let imageViewerTouchStartX = 0;
    let imageViewerTouchStartY = 0;
    let imageViewerTouchStartIndex = 0;
    let imageViewerTouchStarted = false;
    imageViewerViewport?.addEventListener('touchstart', (event) => {
      if (imageSlides.length < 2 || event.touches.length !== 1) {
        imageViewerTouchStarted = false;
        return;
      }
      imageViewerTouchStarted = true;
      imageViewerTouchStartX = event.touches[0].clientX;
      imageViewerTouchStartY = event.touches[0].clientY;
      imageViewerTouchStartIndex = imageViewerIndex;
    }, { passive: true });
    imageViewerViewport?.addEventListener('touchmove', (event) => {
      if (event.touches.length > 1) imageViewerTouchStarted = false;
    }, { passive: true });
    imageViewerViewport?.addEventListener('touchend', (event) => {
      if (!imageViewerTouchStarted || imageSlides.length < 2 || !event.changedTouches.length) return;
      imageViewerTouchStarted = false;
      const deltaX = event.changedTouches[0].clientX - imageViewerTouchStartX;
      const deltaY = event.changedTouches[0].clientY - imageViewerTouchStartY;
      if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
      setImageViewerImage(imageViewerTouchStartIndex + (deltaX < 0 ? 1 : -1), true);
    }, { passive: true });
    imageViewerViewport?.addEventListener('touchcancel', () => {
      imageViewerTouchStarted = false;
    }, { passive: true });
    prev?.addEventListener('click', () => setActive(activeIndex - 1, true, true));
    next?.addEventListener('click', () => setActive(activeIndex + 1, true, true));
    viewport.addEventListener('keydown', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (target?.closest('[data-pdp-media]')) return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        setActive(activeIndex - 1, true, true);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        setActive(activeIndex + 1, true, true);
      }
    });
    viewport.addEventListener('scroll', () => {
      if (scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(() => {
        scrollFrame = null;
        setActive(nearestIndex(), false);
      });
    }, { passive: true });

    let isDragging = false;
    let startX = 0;
    let lastX = 0;
    let startLeft = 0;
    let dragStartIndex = 0;
    viewport.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || slides.length < 2) return;
      const target = event.target instanceof Element ? event.target : null;
      if (target?.closest('[data-pdp-media]')) return;
      isDragging = true;
      startX = event.clientX;
      lastX = event.clientX;
      startLeft = viewport.scrollLeft;
      dragStartIndex = activeIndex;
      viewport.classList.add('dragging');
      viewport.setPointerCapture(event.pointerId);
    });
    viewport.addEventListener('pointermove', (event) => {
      if (!isDragging) return;
      event.preventDefault();
      lastX = event.clientX;
      viewport.scrollLeft = startLeft - (event.clientX - startX);
    });
    const endDrag = () => {
      if (!isDragging) return;
      const delta = startX - lastX;
      isDragging = false;
      viewport.classList.remove('dragging');
      if (Math.abs(delta) > 6) suppressNextSlideClick();
      if (Math.abs(delta) > 40) {
        setActive(dragStartIndex + (delta > 0 ? 1 : -1), true, true);
      } else {
        setActive(nearestIndex(), true, true);
      }
    };
    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('lostpointercapture', endDrag);

    let touchStartX = 0;
    let touchStartY = 0;
    let touchStartIndex = 0;
    let touchStarted = false;
    viewport.addEventListener('touchstart', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (slides.length < 2 || event.touches.length !== 1 || target?.closest('[data-pdp-media]')) {
        touchStarted = false;
        return;
      }
      touchStarted = true;
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
      touchStartIndex = activeIndex;
    }, { passive: true });
    viewport.addEventListener('touchend', (event) => {
      if (!touchStarted || slides.length < 2 || !event.changedTouches.length) return;
      touchStarted = false;
      const deltaX = event.changedTouches[0].clientX - touchStartX;
      const deltaY = event.changedTouches[0].clientY - touchStartY;
      if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
      suppressNextSlideClick();
      setActive(touchStartIndex + (deltaX < 0 ? 1 : -1), true, true);
    }, { passive: true });
    viewport.addEventListener('touchcancel', () => {
      touchStarted = false;
    }, { passive: true });
    viewport.addEventListener('wheel', (event) => {
      if (slides.length < 2 || Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
      const target = event.target instanceof Element ? event.target : null;
      if (target?.closest('[data-pdp-media]')) return;
      const atStart = viewport.scrollLeft <= 1;
      const atEnd = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 1;
      if ((atEnd && event.deltaX > 0) || (atStart && event.deltaX < 0)) {
        event.preventDefault();
        setActive(activeIndex + (event.deltaX > 0 ? 1 : -1), true, true);
      }
    }, { passive: false });

    const initialMediaId = gallery.dataset.initialMediaId;
    let initialIndex = initialMediaId
      ? slides.findIndex((slide) => slide.dataset.mediaId === initialMediaId)
      : -1;
    setActive(initialIndex > -1 ? initialIndex : 0);
    window.requestAnimationFrame(() => {
      const visibleIndex = nearestIndex();
      if (visibleIndex !== activeIndex) {
        setActive(visibleIndex, false);
        return;
      }
      loadSlideNeighborhood(activeIndex);
    });
  });

  document.querySelectorAll('[data-cart-qty-minus], [data-cart-qty-plus]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.parentElement?.querySelector('input');
      if (!input) return;
      const delta = button.hasAttribute('data-cart-qty-plus') ? 1 : -1;
      input.value = Math.max(0, Number(input.value || 0) + delta);
    });
  });

  const loadRecommendations = async (container) => {
    if (!container.dataset.url) return;
    if (container.dataset.loaded === 'true') return;
    container.dataset.loaded = 'true';
    const reserveCurrentHeight = () => {
      const height = Math.ceil(container.getBoundingClientRect().height);
      if (height > 0) container.style.minHeight = `${height}px`;
    };
    const clearPendingState = () => {
      container.classList.remove('is-loading');
      container.removeAttribute('aria-busy');
    };
    const hideEmptyRecommendations = () => {
      clearPendingState();
      container.innerHTML = '';
      container.hidden = true;
    };
    reserveCurrentHeight();
    try {
      const response = await fetch(container.dataset.url, {
        credentials: 'same-origin',
        headers: { Accept: 'text/html' },
        priority: 'low'
      });
      if (!response.ok) {
        hideEmptyRecommendations();
        return;
      }
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      const sectionId = container.dataset.sectionId;
      const recommendations = sectionId
        ? Array.from(html.querySelectorAll('[data-product-recommendations]')).find((section) => section.dataset.sectionId === sectionId)
        : html.querySelector('[data-product-recommendations]');
      const recommendationHtml = recommendations?.innerHTML.trim();
      if (!recommendationHtml) {
        hideEmptyRecommendations();
        return;
      }

      clearPendingState();
      container.hidden = false;
      container.innerHTML = recommendations.innerHTML;
      startDeferredImageLoading(container);
    } catch (error) {
      hideEmptyRecommendations();
    }
  };
  document.querySelectorAll('[data-product-recommendations]').forEach((container) => {
    if (!Object.prototype.hasOwnProperty.call(container.dataset, 'recommendationsPending') && container.matches('.pdp-related--related') && container.querySelector('.pcard')) {
      const heading = container.querySelector('.sec-hdr h2')?.textContent.trim() || 'You may also like';
      const count = Math.min(4, Math.max(2, container.querySelectorAll('.pcard').length || 4));
      const skeletonCards = Array.from({ length: count }, () => `
        <article class="pcard pcard--skeleton">
          <div class="pcard-media pcard-skeleton-media"></div>
          <div>
            <div class="pcard-skeleton-line pcard-skeleton-line--brand"></div>
            <div class="pcard-skeleton-line pcard-skeleton-line--title"></div>
            <div class="pcard-skeleton-line pcard-skeleton-line--price"></div>
          </div>
        </article>
      `).join('');
      const height = Math.ceil(container.getBoundingClientRect().height);
      if (height > 0) container.style.minHeight = `${height}px`;
      container.dataset.recommendationsPending = 'true';
      container.classList.add('is-loading');
      container.setAttribute('aria-busy', 'true');
      container.innerHTML = `
        <div class="pdp-related__loading" data-product-recommendations-placeholder aria-hidden="true">
          <div class="sec-hdr">
            <h2>${escapeHtml(heading)}</h2>
          </div>
          <div class="pgrid pgrid--skeleton">${skeletonCards}</div>
        </div>
      `;
    }

    let started = false;
    const startLoading = () => {
      if (started) return;
      started = true;
      loadRecommendations(container);
    };

    scheduleIdle(startLoading, container.dataset.recommendationsPending === 'true' ? 1200 : 1800);

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        startLoading();
      }, { rootMargin: container.dataset.recommendationsPending === 'true' ? '1400px 0px' : '900px 0px' });
      observer.observe(container);
    } else {
      window.setTimeout(startLoading, 1200);
    }
  });
})();
